'use strict';

var galleryScrollWatch = {

  scrollElementIntoView: function scrollElementIntoView(id) {

    document.getElementById(id).scrollIntoView(true);

    var elementTop = document.getElementById(id).offsetTop;
    window.scrollTo(0, elementTop + 80);
  },

  init: function init() {

    var galleryImages = document.querySelectorAll('.product__photos')[0].querySelectorAll('.product__photo');
    var galleryThumbImages = document.querySelectorAll('.product__thumbs')[0].querySelectorAll('.product__thumb');

    window.onscroll = function () {

      for (var i = 0; i < galleryImages.length; i++) {
        if (galleryImages[i].getBoundingClientRect().top <= 200) {
          for (var j = 0; j < galleryImages.length; j++) {
            galleryImages[j].classList.remove("active");
            galleryThumbImages[j].classList.remove("active");
          }
          galleryImages[i].classList.add("active");
          galleryThumbImages[i].classList.add("active");
        }
      }
    };
  }
};
'use strict';

var accordion = function () {

  var $accordion = $('.js-accordion');
  var $accordion_header = $accordion.find('.js-accordion-header');
  var $accordion_item = $('.js-accordion-item');

  // default settings 
  var settings = {
    // animation speed
    speed: 400,

    // close all other accordion items if true
    oneOpen: false
  };

  return {
    // pass configurable object literal
    init: function init($settings) {
      $accordion_header.on('click', function () {
        accordion.toggle($(this));
      });

      $.extend(settings, $settings);

      // ensure only one accordion is active if oneOpen is true
      if (settings.oneOpen && $('.js-accordion-item.active').length > 1) {
        $('.js-accordion-item.active:not(:first)').removeClass('active');
      }

      // reveal the active accordion bodies
      $('.js-accordion-item.active').find('> .js-accordion-body').show();
    },
    toggle: function toggle($this) {

      if (settings.oneOpen && $this[0] != $this.closest('.js-accordion').find('> .js-accordion-item.active > .js-accordion-header')[0]) {
        $this.closest('.js-accordion').find('> .js-accordion-item').removeClass('active').find('.js-accordion-body').slideUp();
      }

      // show/hide the clicked accordion item
      $this.closest('.js-accordion-item').toggleClass('active');
      $this.next().stop().slideToggle(settings.speed);
    }
  };
}();

$(document).ready(function () {
  accordion.init({ speed: 300, oneOpen: false });
});
'use strict';

window.AccountMiniNav = {

  click: function click() {
    var miniNavEl = document.getElementById('account-mini-nav');

    if (miniNavEl.classList.contains('account-mini-nav--isOpen')) {
      // its open close it

      miniNavEl.classList.remove('account-mini-nav--isOpen');
    } else {
      // open it
      miniNavEl.classList.add('account-mini-nav--isOpen');
    }
  }
};

window.Account = {

  addAddress: function addAddress(status) {
    var el = document.getElementById('AddressNewForm');
    if (status == 'show') {
      el.classList.add('isVisible');
    } else {
      el.classList.remove('isVisible');
    }
  },

  changeView: function changeView(link, newView) {

    console.log(link);
    // hide current view
    if (!link.classList.contains('active')) {

      // remove current view
      document.querySelectorAll('.account-navigation__link.active')[0].classList.remove('active');
      document.querySelectorAll('.account-view.isVisible')[0].classList.remove('isVisible');

      // show current view
      link.classList.add('active');
      document.getElementById('view-' + newView).classList.add('isVisible');
    }
  }
};
'use strict';

window.addedToCartPrompts = [];

window.displayAddedToCartNotification = function (productHandle, variantId) {

    if (!productHandle || !variantId) return;

    var addedToCartNotificationEl = document.getElementById('AddedToCartNotification');

    if (!addedToCartNotificationEl) return;

    fetch('/products/' + productHandle + '?variant=' + variantId + '&view=added-to-cart-info').then(function (response) {
        return response.text();
    }).then(function (response) {

        addedToCartNotificationEl.children[2].innerHTML = response;
        document.body.classList.add('added-to-cart');

        window.addedToCartPrompts.push(1);

        setTimeout(function () {

            window.addedToCartPrompts.pop();

            if (window.addedToCartPrompts.length > 0) return;

            document.body.classList.remove('added-to-cart');
        }, 5000);
    });
};

(function () {
    var closeAddedToCartNotificationBtn = document.getElementById('CloseAddedToCartNotification');

    if (closeAddedToCartNotificationBtn) {
        closeAddedToCartNotificationBtn.addEventListener('click', function () {
            window.addedToCartPrompts.pop();
            document.body.classList.remove('added-to-cart');
        });
    }
})();
'use strict';

(function () {

    var enquiryForm = document.getElementById('AirTableEnquiry');

    if (!enquiryForm) return;

    var fields = enquiryForm.querySelectorAll('input, textarea');

    enquiryForm.addEventListener('submit', function (e) {
        e.preventDefault();

        var reqData = {
            air_table_configuration_token: this.dataset.configurationToken
        };

        var requiredFields = [];

        var errors = [];

        for (var i = 0; i < fields.length; i++) {

            fields[i].addEventListener('change', onInputChange);
            fields[i].addEventListener('input', onInputChange);

            if (fields[i].type == 'checkbox') {

                if (typeof fields[i].dataset.multi == 'undefined') {

                    //Not mutliple choice 

                    reqData[fields[i].name] = fields[i].checked;

                    if (typeof this.dataset.required != 'undefined') {
                        requiredFields.push({ name: fields[i].name, type: "boolean" });
                    }

                    continue;
                }

                //Is Multiple Choice

                if (typeof reqData[fields[i].name] == 'undefined') {
                    reqData[fields[i].name] = [];
                }

                if (fields[i].checked) {
                    reqData[fields[i].name].push(fields[i].value);
                }

                if (typeof fields[i].dataset.required != 'undefined') {
                    requiredFields.push({ name: fields[i].name, type: "array" });
                }

                continue;
            }

            if (typeof fields[i].dataset.linkTableName != 'undefined' && typeof fields[i].dataset.linkByField != 'undefined' && typeof fields[i].dataset.required != 'undefined') {
                reqData[fields[i].name] = {
                    link_table: fields[i].dataset.linkTableName,
                    link_field: fields[i].dataset.linkByField,
                    value: fields[i].value
                };
                requiredFields.push({ name: fields[i].name, type: "linked" });
                continue;
            }

            if (typeof fields[i].dataset.required != 'undefined') {
                requiredFields.push({ name: fields[i].name, type: "string" });
            }

            reqData[fields[i].name] = fields[i].value;
        }

        for (var _i = 0; _i < requiredFields.length; _i++) {
            switch (requiredFields[_i].type) {
                case "string":
                    if (reqData[requiredFields[_i].name].trim().length < 1) {
                        errors.push({ for: requiredFields[_i].name, message: "Field is required" });
                    }
                    break;
                case "boolean":
                    if (!reqData[requiredFields[_i].name]) {
                        errors.push({ for: requiredFields[_i].name, message: "Field is required" });
                    }
                    break;
                case 'linked':
                    if (reqData[requiredFields[_i].name].value.trim().length < 1) {
                        errors.push({ for: requiredFields[_i].name, message: "Field is required" });
                    }
                    break;
                case "array":
                    if (reqData[requiredFields[_i].name].length < 1) {
                        errors.push({ for: requiredFields[_i].name, message: "You must select at least one option" });
                    }
                    break;
            }
        }

        if (errors.length > 0) {
            for (var _i2 = 0; _i2 < errors.length; _i2++) {
                var fieldEl = enquiryForm.querySelector('[name="' + errors[_i2].for + '"]');
                if (!fieldEl) continue;
                fieldEl.parentNode.classList.add('field-error');
                var errorMessageEl = fieldEl.parentNode.querySelector('.error');
                if (errorMessageEl) {
                    errorMessageEl.innerHTML = errors[_i2].message;
                }
            }

            return;
        }

        fetch('https://site-apps.muttmotorcycles.com/air-table-submit', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(reqData)
        }).then(function (response) {
            return response.json();
        }).then(function (json) {
            if (json.status == 'SUCCESS') {
                enquiryForm.style.display = 'none';
                document.getElementsByClassName('air-table-success')[0].style.display = 'block';
            } else if (json.status == 'ERROR') {
                alert("There was an unknown error submitting the form");
                console.log(json);
            }
        });
    });

    var onInputChange = function onInputChange(e) {
        for (var i = 0; i < fields.length; i++) {
            if (!fields[i].parentNode.classList.contains('field-error')) continue;
            fields[i].parentNode.classList.remove('field-error');
        }
    };
})();
'use strict';

(function () {

    var backToTopBtn = document.getElementById('BackToTop');

    if (!backToTopBtn) return;

    backToTopBtn.addEventListener('click', function (e) {
        e.preventDefault();
        window.scrollTo(document.documentElement, 0, 800);
    });

    window.addEventListener('scroll', function () {
        if (document.documentElement.scrollTop > 100 && !backToTopBtn.classList.contains('show')) {
            backToTopBtn.classList.add('show');
        } else if (document.documentElement.scrollTop <= 100 && backToTopBtn.classList.contains('show')) {
            backToTopBtn.classList.remove('show');
        }
    });
})();
'use strict';

(function () {

    var enquiryInterestEL = document.getElementById('EnquiryInterest');

    if (!enquiryInterestEL) return;

    if (document.referrer.indexOf('/products/') == -1) return;

    var handle = document.referrer.split('/products/').pop();

    if (handle.indexOf('?') != -1) {
        handle = handle.split('?')[0];
    }

    var enquiryInterestOptionEls = enquiryInterestEL.children[2].children;

    for (var i = 0; i < enquiryInterestOptionEls.length; i++) {
        if (enquiryInterestOptionEls[i].dataset.handle != handle) continue;
        enquiryInterestEL.children[0].value = enquiryInterestOptionEls[i].dataset.value;
        enquiryInterestEL.children[1].innerHTML = enquiryInterestOptionEls[i].innerHTML;
        break;
    }
})();
'use strict';

(function () {

    var bikeMobileNavToggleBtn = document.getElementById('BikeMobileNavToggle');

    if (bikeMobileNavToggleBtn) {
        var bikeMobileNavMenuEl = document.getElementsByClassName('action-toolbar-mobile-nav')[0] || null;

        document.addEventListener('click', function (e) {
            if (!bikeMobileNavMenuEl) return;

            if (!bikeMobileNavMenuEl.classList.contains('show')) {
                if (DOMHelper.isNodeOrIsChildOfNode(e.target, bikeMobileNavToggleBtn)) {
                    bikeMobileNavMenuEl.classList.add('show');
                }
            } else {
                bikeMobileNavMenuEl.classList.remove('show');
            }
        });
    }
})();
'use strict';

/*!
 * Bootstrap v3.3.5 (http://getbootstrap.com)
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 */

/*!
 * Generated using the Bootstrap Customizer (http://getbootstrap.com/customize/?id=3356eb28a4f746ca1528)
 * Config saved to config.json and https://gist.github.com/3356eb28a4f746ca1528
 */
if (typeof jQuery === 'undefined') {
  throw new Error('Bootstrap\'s JavaScript requires jQuery');
}
+function ($) {
  'use strict';

  var version = $.fn.jquery.split(' ')[0].split('.');
  if (version[0] < 2 && version[1] < 9 || version[0] == 1 && version[1] == 9 && version[2] < 1 || version[0] > 2) {
    throw new Error('Bootstrap\'s JavaScript requires jQuery version 1.9.1 or higher, but lower than version 3');
  }
}(jQuery);

/* ========================================================================
 * Bootstrap: dropdown.js v3.3.6
 * http://getbootstrap.com/javascript/#dropdowns
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  'use strict';

  // DROPDOWN CLASS DEFINITION
  // =========================

  var backdrop = '.dropdown-backdrop';
  var toggle = '[data-toggle="dropdown"]';
  var Dropdown = function Dropdown(element) {
    $(element).on('click.bs.dropdown', this.toggle);
  };

  Dropdown.VERSION = '3.3.6';

  function getParent($this) {
    var selector = $this.attr('data-target');

    if (!selector) {
      selector = $this.attr('href');
      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, ''); // strip for ie7
    }

    var $parent = selector && $(selector);

    return $parent && $parent.length ? $parent : $this.parent();
  }

  function clearMenus(e) {
    if (e && e.which === 3) return;
    $(backdrop).remove();
    $(toggle).each(function () {
      var $this = $(this);
      var $parent = getParent($this);
      var relatedTarget = { relatedTarget: this };

      if (!$parent.hasClass('open')) return;

      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return;

      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget));

      if (e.isDefaultPrevented()) return;

      $this.attr('aria-expanded', 'false');
      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget));
    });
  }

  Dropdown.prototype.toggle = function (e) {
    var $this = $(this);

    if ($this.is('.disabled, :disabled')) return;

    var $parent = getParent($this);
    var isActive = $parent.hasClass('open');

    clearMenus();

    if (!isActive) {
      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
        // if mobile we use a backdrop because click events don't delegate
        $(document.createElement('div')).addClass('dropdown-backdrop').insertAfter($(this)).on('click', clearMenus);
      }

      var relatedTarget = { relatedTarget: this };
      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget));

      if (e.isDefaultPrevented()) return;

      $this.trigger('focus').attr('aria-expanded', 'true');

      $parent.toggleClass('open').trigger($.Event('shown.bs.dropdown', relatedTarget));
    }

    return false;
  };

  Dropdown.prototype.keydown = function (e) {
    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return;

    var $this = $(this);

    e.preventDefault();
    e.stopPropagation();

    if ($this.is('.disabled, :disabled')) return;

    var $parent = getParent($this);
    var isActive = $parent.hasClass('open');

    if (!isActive && e.which != 27 || isActive && e.which == 27) {
      if (e.which == 27) $parent.find(toggle).trigger('focus');
      return $this.trigger('click');
    }

    var desc = ' li:not(.disabled):visible a';
    var $items = $parent.find('.dropdown-menu' + desc);

    if (!$items.length) return;

    var index = $items.index(e.target);

    if (e.which == 38 && index > 0) index--; // up
    if (e.which == 40 && index < $items.length - 1) index++; // down
    if (!~index) index = 0;

    $items.eq(index).trigger('focus');
  };

  // DROPDOWN PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data('bs.dropdown');

      if (!data) $this.data('bs.dropdown', data = new Dropdown(this));
      if (typeof option == 'string') data[option].call($this);
    });
  }

  var old = $.fn.dropdown;

  $.fn.dropdown = Plugin;
  $.fn.dropdown.Constructor = Dropdown;

  // DROPDOWN NO CONFLICT
  // ====================

  $.fn.dropdown.noConflict = function () {
    $.fn.dropdown = old;
    return this;
  };

  // APPLY TO STANDARD DROPDOWN ELEMENTS
  // ===================================

  $(document).on('click.bs.dropdown.data-api', clearMenus).on('click.bs.dropdown.data-api', '.dropdown form', function (e) {
    e.stopPropagation();
  }).on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle).on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown).on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown);
}(jQuery);
'use strict';

var CartNew = {

    updateShopifyCartItems: function updateShopifyCartItems(method, el, callback) {

        if (document.getElementsByClassName('template-cart').length > 0) {

            var qty = parseInt(el.parentNode.querySelectorAll('.js-qty__num')[0].value);

            if (method == 'add') {
                qty = 1;
            } else {
                qty = qty - 1;
            }

            var item = {
                id: parseInt(el.getAttribute('data-id')),
                quantity: qty // parseInt(qty.value)
            };

            console.log(method, item);

            var url = '/cart/' + method + '.js';
            var updates = [];

            if (method == 'remove') {
                var url = '/cart/update.js';
                var updates = {};
                //item.quantity = item.quantity - 1;
                updates[item.id] = item.quantity;
                item = { updates: updates };
            }

            fetch(url, {
                body: JSON.stringify(item),
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'xmlhttprequest'
                },
                method: 'POST'
            }).then(function (response) {
                return response.json();
            }).then(function (json) {
                /* we have JSON */

                callback();
            }).catch(function (err) {
                /* uh oh, we have error. */
                console.error(err);
            });
        }
    },

    quantityClick: function quantityClick(el, type) {

        var quantityEl = el.parentNode.querySelectorAll('.js-qty__num')[0];
        // type is either + or -

        if (type === '+') {
            // adding to cart
            type = 'add';
        } else {
            // removing from cart
            type = 'remove';
        }

        // ajax call to update cart values
        CartNew.updateShopifyCartItems(type, quantityEl, function () {
            console.log('updated cart items');

            // ajax call cart page and get html

            fetch('cart', {
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'text/html',
                    'X-Requested-With': 'xmlhttprequest'
                },
                method: 'GET'
            }).then(function (response) {

                return response.text();
            }).then(function (responseHTML) {
                /* we have JSON */

                var cartPageHTML = responseHTML.split('<!--[AJAX-CART-PAGE]-->').pop().split('<!--[/AJAX-CART-PAGE]-->')[0];

                document.getElementById('ajax-cart').parentElement.innerHTML = cartPageHTML;

                // init qty button
                ajaxCart.init();
                if (typeof callback == 'function') {
                    callback();
                }
            }).catch(function (err) {
                /* uh oh, we have error. */
                console.error(err);
            });
        });
    }
};
'use strict';

$(document).ready(function () {
    $('.img-overlay-addtocart').unbind("click");
    $('.img-overlay-addtocart').off("click");

    $(document).on('click', '.size-option:not(.strikethrough)', function (e) {
        e.preventDefault();

        if ($(this).hasClass('active')) {
            $(this).removeClass("active");
            $(this).parents('form').removeClass('option-selected');
            return;
        }

        $(this).parent('ul').find('.size-option.active').removeClass("active");
        $(this).addClass("active");
        var prodid = $(this).data("productid");
        $('#' + prodid).val($(this).data('id'));
        $('.submit-' + prodid).data('selectable', true);
        $(this).parents('form').addClass('option-selected');
    });

    $(document).on('click', '.img-overlay-addtocart', function (e) {
        e.preventDefault();
        if ($(this).data('selectable') == true) {
            var parentForm = $(this).parent('form');
            $(this).val("Adding To Bag");
            var $addToCartBtn = $(this),
                $addToCartForm = $(this).closest('form'),
                $addToCartBtnText = $(this).find('span');
            $addToCartBtn.removeClass("btn--loading");
            $addToCartBtn.removeClass("btn--done");
            if ($addToCartForm.length) {
                $addToCartBtn.attr('data-add-to-cart', $addToCartBtnText.text())
                //.prop('disabled', true)
                .addClass('disabled').addClass('btn--loading');
                $.ajax({
                    url: '/cart/add.js',
                    dataType: 'json',
                    type: 'post',
                    data: $addToCartForm.serialize()
                }).success(function (data) {
                    $addToCartBtn.val("Item Added To Bag");
                    $addToCartBtn.removeClass("btn--loading");
                    $addToCartBtn.addClass("btn--done");
                    $('.item-count').html(parseInt($('.item-count').html()) + 1);

                    parentForm.removeClass('option-selected');
                    parentForm.find('.size-option.active').removeClass('active');

                    window.displayAddedToCartNotification(data.handle, data.variant_id);
                });
            }
        } else {
            $(this).val("please Select a Size");
        }
    });

    $('.list-changer .list-4').on('click', function () {
        $(this).addClass('active');
        $('body').addClass('hide-card-text');
        $('.list-changer .list-3').removeClass('active');
    });

    $('.list-changer .list-3').on('click', function () {
        $(this).addClass('active');
        $('body').removeClass('hide-card-text');
        $('.list-changer .list-4').removeClass('active');
    });
    $('.list-changer .list-two-column').on('click', function () {
        $(this).addClass('active');
        $('body').addClass('hide-card-text');
        $('.list-changer .list-three-column').removeClass('active');
    });
    $('.list-changer .list-three-column').on('click', function () {
        $(this).addClass('active');
        $('body').removeClass('hide-card-text');
        $('.list-changer .list-two-column').removeClass('active');
    });
});
'use strict';

var common = function ($) {
    'use strict';

    /**
     * Some function
     *
     * @since   1.0.0
     */

    var someFunction = function someFunction() {
        // do something
    };

    /**
     * Fire events on document ready and bind other events
     *
     * @since   1.0.0
     */
    var ready = function ready() {
        someFunction();
    };

    /**
     * Only expose the ready function to the world
     */
    return {
        ready: ready
    };
}(jQuery);

jQuery(common.ready);
'use strict';

var CovidBanner = {

    remove: function remove() {

        // hide banner using cookies
        var bannerEl = document.getElementsByClassName('covid-banner')[0];
        bannerEl.remove();

        CovidBanner.createCookie('hide-covid-banner', true);
    },

    toggle: function toggle() {

        var htmlEl = document.getElementsByTagName('html')[0];

        if (htmlEl.classList.contains('covid-banner--overlayIsVisible')) {
            CovidBanner.hide();
        } else {
            CovidBanner.show();
        }
    },

    show: function show() {
        var htmlEl = document.getElementsByTagName('html')[0];
        htmlEl.classList.add('covid-banner--overlayIsVisible');

        // prevent link from going anywhere
        return false;
    },

    hide: function hide() {
        var htmlEl = document.getElementsByTagName('html')[0];
        htmlEl.classList.remove('covid-banner--overlayIsVisible');

        // prevent link from going anywhere
        return false;
    },

    createCookie: function createCookie(name, value, days) {
        var expires;
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = "; expires=" + date.toGMTString();
        } else {
            expires = "";
        }
        document.cookie = name + "=" + value + expires + "; path=/";
    },

    getCookie: function getCookie(c_name) {
        if (document.cookie.length > 0) {
            var c_start = document.cookie.indexOf(c_name + "=");
            if (c_start != -1) {
                c_start = c_start + c_name.length + 1;
                var c_end = document.cookie.indexOf(";", c_start);
                if (c_end == -1) {
                    c_end = document.cookie.length;
                }
                return unescape(document.cookie.substring(c_start, c_end));
            }
        }
        return "";
    },

    init: function init() {

        if (!CovidBanner.getCookie('hide-covid-banner')) {
            var bannerEl = document.getElementsByClassName('covid-banner')[0] || null;

            if (bannerEl) {
                bannerEl.style.display = 'initial';
                document.documentElement.classList.add('covid-banner--isVisible');
            }
        }
    }
};

CovidBanner.init();
'use strict';

(function () {

    var sliders = document.querySelectorAll('.scrolling-products__products');

    var isDown = false;
    var startX = void 0;
    var scrollLeft = void 0;
    var moved = false;

    for (var i = 0; i < sliders.length; i++) {
        sliders[i].addEventListener('mousedown', function (e) {
            isDown = true;
            this.classList.add('drag-active');
            startX = e.pageX - this.offsetLeft;
            scrollLeft = this.scrollLeft;
        });

        sliders[i].addEventListener('mouseleave', function (e) {
            isDown = false;
            this.classList.remove('drag-active');
        });

        sliders[i].addEventListener('mouseup', function (e) {
            if (moved) {
                e.preventDefault();
                moved = false;
            }
            isDown = false;
            this.classList.remove('drag-active');
        });

        sliders[i].addEventListener('mousemove', function (e) {
            if (!isDown) return;
            e.preventDefault();
            var x = e.pageX - this.offsetLeft;
            var walk = (x - startX) * 3; //scroll-fast
            var newScrollLeft = scrollLeft - walk;

            console.log(e.movementX);
            if (Math.abs(this.scrollLeft - newScrollLeft) > 5) {
                moved = true;
                //console.log(Math.abs(this.scrollLeft - newScrollLeft));
            }

            this.scrollLeft = newScrollLeft;
        });
    }
})();
"use strict";

var DOMHelper = {

    /* 
    * Let's you query a parent element 
    * returns null if none is found
    */
    queryParentEl: function queryParentEl(el, selector) {
        if (!el) return null;

        var parent = el.parentElement;
        var i = 0;

        while (parent) {
            if (parent.matches(selector)) {
                return parent;
            }

            parent = parent.parentElement;
            i++;

            if (i > 500) {
                console.warn("Iteration limit of 500 reached for DOMHelper.queryParent()");
                break;
            }
        }

        return null;
    },

    isNodeOrIsChildOfNode: function isNodeOrIsChildOfNode(node, matchNode) {

        while (node) {
            if (node.isEqualNode(matchNode)) {
                return true;
            }
            node = node.parentNode;
        }

        return false;
    }

};
'use strict';

var DrawerMenu = {

    show: function show() {
        var htmlEl = document.documentElement;
        // add visible class to html element
        htmlEl.classList.add('drawer-menu__isVisible');

        if (htmlEl.classList.contains('search-mobile--isVisible')) {
            htmlEl.classList.remove('search-mobile--isVisible');
        }
    },

    hide: function hide() {
        var htmlEl = document.documentElement;

        // check if there is a product overlay first
        var productOverlay = document.querySelectorAll('.drawer-menu__product-overlay.active')[0];
        if (productOverlay) {
            productOverlay.classList.remove('active');
            return false;
        }

        if (htmlEl.classList.contains('search-mobile--isVisible')) {
            SearchMobile.toggleView();
            return false;
        }

        // remove visible class to html element
        htmlEl.classList.remove('drawer-menu__isVisible');

        // remove active classes
        var activeLevelList = document.querySelectorAll('.drawer-menu__level.active');
        for (var i = 0; i < activeLevelList.length; i++) {
            activeLevelList[i].classList.remove('active');
        }
    },

    clickBtnNext: function clickBtnNext(btnNext, preventDefault) {
        // add active to div aside to it
        var nextLevelEl = btnNext.parentNode.querySelectorAll('.drawer-menu__level')[0];

        nextLevelEl.classList.add('active');

        if (preventDefault) {
            return false;
        }
        return true;
    },

    clickBtnBack: function clickBtnBack(btnBack) {
        // add active to div aside to it
        var previousLevelEl = btnBack.parentNode.parentNode;

        previousLevelEl.classList.remove('active');
    },

    displayProductOverlay: function displayProductOverlay(productUrl) {

        var el = document.querySelectorAll('[data-product-url="' + productUrl + '"]')[0];
        el.classList.add('active');
    },

    getProductData: function getProductData() {
        var itemList = document.querySelectorAll('[data-product-url]');

        for (var i = 0; i < itemList.length; i++) {

            var productUrl = itemList[i].getAttribute('data-product-url');

            productUrl = location.origin + productUrl;

            fetch(productUrl + '?view=menu-bike-overview', {
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'text/html',
                    'method': 'get'
                }
            }).then(function (data) {
                return data.text();
            }).then(function (data) {

                var data = data.split("|");

                var obj = {
                    html: data[1],
                    url: '/products/' + data[0]
                };

                DrawerMenu.setProductOverlay(obj.html, obj.url);

                setTimeout(function () {
                    window.renderSpecifcationTables();
                }, 1000);
            }).catch(function (err) {
                /* uh oh, we have error. */
                console.error(err);
            });
        }
    },

    setProductOverlay: function setProductOverlay(html, productUrl) {
        var el = document.querySelectorAll('[data-product-url="' + productUrl + '"]')[0];
        el.innerHTML = html;
    }
};
'use strict';

(function () {

    var dropdownToggleEls = document.getElementsByClassName('dropdown-toggle');

    document.addEventListener('click', function (e) {

        for (var i = 0; i < dropdownToggleEls.length; i++) {
            if (!dropdownToggleEls[i].parentNode.classList.contains('open')) {

                if (DOMHelper.isNodeOrIsChildOfNode(e.target, dropdownToggleEls[i])) {
                    e.preventDefault();
                    dropdownToggleEls[i].parentNode.classList.add('open');
                }
            } else {
                dropdownToggleEls[i].parentNode.classList.remove('open');
            }
        }
    });

    var fancyDropdownOptEls = document.querySelectorAll('.fancy-dropdown ul.options li');

    for (var i = 0; i < fancyDropdownOptEls.length; i++) {
        fancyDropdownOptEls[i].addEventListener('click', function (e) {
            var inputFieldEl = this.parentNode.parentNode.querySelector('input[type="hidden"]');
            var dropdownToggleEl = this.parentNode.parentNode.querySelector('.dropdown-toggle');

            if (inputFieldEl) {
                inputFieldEl.value = this.dataset.value;
            }

            if (dropdownToggleEl) {
                dropdownToggleEl.innerHTML = this.innerHTML;
            }
        });
    }
})();
'use strict';

(function () {

    document.addEventListener('click', function (e) {
        var el = e.target.matches('[data-add-to-favourites]') ? e.target : DOMHelper.queryParentEl(e.target, '[data-add-to-favourites]');

        if (!el) return;

        e.preventDefault();

        if (!cake.customer_id) {
            window.displayInfoPopup('FavLoginPrompt');
            return;
        }

        var product_handle = el.getAttribute('data-add-to-favourites');
        var action = el.classList.contains('added') ? 'remove' : 'add';

        if (action == 'add') {
            el.classList.add('added');
        } else {
            el.classList.remove('added');
        }

        var formData = new FormData();

        formData.append('action', action);
        formData.append('customer_id', cake.customer_id);
        formData.append('product_handle', product_handle);

        fetch('https://garage.muttmotorcycles.com/favourites.php', {
            method: 'POST',
            headers: { 'X-Security-Token': cake.customer_api_token },
            body: formData
        }).then(function (response) {
            return response.json();
        }).then(function (response) {

            document.dispatchEvent(new CustomEvent('updatedFavourites', {
                detail: {
                    action: action,
                    product_handle: product_handle
                }
            }));
        }).catch(function (err) {
            console.log(err);
            alert('There was an error adding to favourites');

            if (action == 'add') {
                el.classList.remove('added');
            } else {
                el.classList.add('added');
            }
        });
    });
})();

(function () {

    document.addEventListener('updatedFavourites', function (e) {

        var query = '[data-add-to-favourites="' + e.detail.product_handle + '"]';

        if (e.detail.action == 'add') {
            query += ":not(.added)";
        } else {
            query += ".added";
        }

        var btns = document.querySelectorAll(query);

        for (var i = 0; i < btns.length; i++) {
            if (e.detail.action == 'add') {
                btns[i].classList.add('added');
            } else {
                btns[i].classList.remove('added');
            }
        }

        if (e.detail.action == 'remove') {
            var customerFavoruitesListEl = document.querySelector('.customer-favourites .scrolling-products__products');
        }
    });
})();
'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function () {
    var _countryCodeNameMap;

    if (!document.getElementById('FindDealerMap')) return;

    var dealerItemTmpl = document.getElementById('DealerListItem');

    var findADealerForm = document.getElementById('FindADealerSearchForm');

    var mapScript = document.createElement('script');
    mapScript.src = '//maps.googleapis.com/maps/api/js?sensor=false&callback=initializeDealerMap&key=AIzaSyAqBqvj3dpS0ij-06KEjupb-rza-Bj40Jc&signature=mIzRr9ppqzPK8DCb4Dt-sFK1y5U=';
    document.head.appendChild(mapScript);

    var map;
    var bounds;
    var mapOptions;

    var address = null;
    var country = 'GB';

    var renderedMarkers = [];

    var countryCodeNameMap = (_countryCodeNameMap = {
        "GB": "United Kingdom",
        "IE": "Ireland",
        "GG": "Guernsey",
        "FR": "France",
        "JP": "Japan",
        "PT": "Portugal",
        "ES": "Spain",
        "IT": "Italy",
        "AU": "Australia",
        "NZ": "New Zealand",
        "US": "United States",
        "CA": "Canada",
        "KR": "Korea",
        "DE": "Germany",
        "AF": "Afghanistan",
        "AX": "Åland Islands",
        "AL": "Albania",
        "DZ": "Algeria",
        "AS": "American Samoa",
        "AD": "Andorra",
        "AO": "Angola",
        "AI": "Anguilla",
        "AQ": "Antarctica",
        "AG": "Antigua and Barbuda",
        "AR": "Argentina",
        "AM": "Armenia",
        "AW": "Aruba"
    }, _defineProperty(_countryCodeNameMap, 'AU', "Australia"), _defineProperty(_countryCodeNameMap, "AT", "Austria"), _defineProperty(_countryCodeNameMap, "AZ", "Azerbaijan"), _defineProperty(_countryCodeNameMap, "BS", "Bahamas"), _defineProperty(_countryCodeNameMap, "BH", "Bahrain"), _defineProperty(_countryCodeNameMap, "BD", "Bangladesh"), _defineProperty(_countryCodeNameMap, "BB", "Barbados"), _defineProperty(_countryCodeNameMap, "BY", "Belarus"), _defineProperty(_countryCodeNameMap, "BE", "Belgium"), _defineProperty(_countryCodeNameMap, "BZ", "Belize"), _defineProperty(_countryCodeNameMap, "BJ", "Benin"), _defineProperty(_countryCodeNameMap, "BM", "Bermuda"), _defineProperty(_countryCodeNameMap, "BT", "Bhutan"), _defineProperty(_countryCodeNameMap, "BO", "Bolivia, Plurinational State of"), _defineProperty(_countryCodeNameMap, "BQ", "Bonaire, Sint Eustatius and Saba"), _defineProperty(_countryCodeNameMap, "BA", "Bosnia and Herzegovina"), _defineProperty(_countryCodeNameMap, "BW", "Botswana"), _defineProperty(_countryCodeNameMap, "BV", "Bouvet Island"), _defineProperty(_countryCodeNameMap, "BR", "Brazil"), _defineProperty(_countryCodeNameMap, "IO", "British Indian Ocean Territory"), _defineProperty(_countryCodeNameMap, "BN", "Brunei Darussalam"), _defineProperty(_countryCodeNameMap, "BG", "Bulgaria"), _defineProperty(_countryCodeNameMap, "BF", "Burkina Faso"), _defineProperty(_countryCodeNameMap, "BI", "Burundi"), _defineProperty(_countryCodeNameMap, "KH", "Cambodia"), _defineProperty(_countryCodeNameMap, "CM", "Cameroon"), _defineProperty(_countryCodeNameMap, "CV", "Cape Verde"), _defineProperty(_countryCodeNameMap, "KY", "Cayman Islands"), _defineProperty(_countryCodeNameMap, "CF", "Central African Republic"), _defineProperty(_countryCodeNameMap, "TD", "Chad"), _defineProperty(_countryCodeNameMap, "CL", "Chile"), _defineProperty(_countryCodeNameMap, "CN", "China"), _defineProperty(_countryCodeNameMap, "CX", "Christmas Island"), _defineProperty(_countryCodeNameMap, "CC", "Cocos (Keeling) Islands"), _defineProperty(_countryCodeNameMap, "CO", "Colombia"), _defineProperty(_countryCodeNameMap, "KM", "Comoros"), _defineProperty(_countryCodeNameMap, "CG", "Congo"), _defineProperty(_countryCodeNameMap, "CD", "Congo, the Democratic Republic of the"), _defineProperty(_countryCodeNameMap, "CK", "Cook Islands"), _defineProperty(_countryCodeNameMap, "CR", "Costa Rica"), _defineProperty(_countryCodeNameMap, "CI", "Côte d'Ivoire"), _defineProperty(_countryCodeNameMap, "HR", "Croatia"), _defineProperty(_countryCodeNameMap, "CU", "Cuba"), _defineProperty(_countryCodeNameMap, "CW", "Curaçao"), _defineProperty(_countryCodeNameMap, "CY", "Cyprus"), _defineProperty(_countryCodeNameMap, "CZ", "Czech Republic"), _defineProperty(_countryCodeNameMap, "DK", "Denmark"), _defineProperty(_countryCodeNameMap, "DJ", "Djibouti"), _defineProperty(_countryCodeNameMap, "DM", "Dominica"), _defineProperty(_countryCodeNameMap, "DO", "Dominican Republic"), _defineProperty(_countryCodeNameMap, "EC", "Ecuador"), _defineProperty(_countryCodeNameMap, "EG", "Egypt"), _defineProperty(_countryCodeNameMap, "SV", "El Salvador"), _defineProperty(_countryCodeNameMap, "GQ", "Equatorial Guinea"), _defineProperty(_countryCodeNameMap, "ER", "Eritrea"), _defineProperty(_countryCodeNameMap, "EE", "Estonia"), _defineProperty(_countryCodeNameMap, "ET", "Ethiopia"), _defineProperty(_countryCodeNameMap, "FK", "Falkland Islands (Malvinas)"), _defineProperty(_countryCodeNameMap, "FO", "Faroe Islands"), _defineProperty(_countryCodeNameMap, "FJ", "Fiji"), _defineProperty(_countryCodeNameMap, "FI", "Finland"), _defineProperty(_countryCodeNameMap, 'FR', "France"), _defineProperty(_countryCodeNameMap, "GF", "French Guiana"), _defineProperty(_countryCodeNameMap, "PF", "French Polynesia"), _defineProperty(_countryCodeNameMap, "TF", "French Southern Territories"), _defineProperty(_countryCodeNameMap, "GA", "Gabon"), _defineProperty(_countryCodeNameMap, "GM", "Gambia"), _defineProperty(_countryCodeNameMap, "GE", "Georgia"), _defineProperty(_countryCodeNameMap, 'DE', "Germany"), _defineProperty(_countryCodeNameMap, "GH", "Ghana"), _defineProperty(_countryCodeNameMap, "GI", "Gibraltar"), _defineProperty(_countryCodeNameMap, "GR", "Greece"), _defineProperty(_countryCodeNameMap, "GL", "Greenland"), _defineProperty(_countryCodeNameMap, "GD", "Grenada"), _defineProperty(_countryCodeNameMap, "GP", "Guadeloupe"), _defineProperty(_countryCodeNameMap, "GU", "Guam"), _defineProperty(_countryCodeNameMap, "GT", "Guatemala"), _defineProperty(_countryCodeNameMap, "GN", "Guinea"), _defineProperty(_countryCodeNameMap, "GW", "Guinea-Bissau"), _defineProperty(_countryCodeNameMap, "GY", "Guyana"), _defineProperty(_countryCodeNameMap, "HT", "Haiti"), _defineProperty(_countryCodeNameMap, "HM", "Heard Island and McDonald Islands"), _defineProperty(_countryCodeNameMap, "VA", "Holy See (Vatican City State)"), _defineProperty(_countryCodeNameMap, "HN", "Honduras"), _defineProperty(_countryCodeNameMap, "HK", "Hong Kong"), _defineProperty(_countryCodeNameMap, "HU", "Hungary"), _defineProperty(_countryCodeNameMap, "IS", "Iceland"), _defineProperty(_countryCodeNameMap, "IN", "India"), _defineProperty(_countryCodeNameMap, "ID", "Indonesia"), _defineProperty(_countryCodeNameMap, "IR", "Iran, Islamic Republic of"), _defineProperty(_countryCodeNameMap, "IQ", "Iraq"), _defineProperty(_countryCodeNameMap, "IM", "Isle of Man"), _defineProperty(_countryCodeNameMap, "IL", "Israel"), _defineProperty(_countryCodeNameMap, "JM", "Jamaica"), _defineProperty(_countryCodeNameMap, 'JP', "Japan"), _defineProperty(_countryCodeNameMap, "JE", "Jersey"), _defineProperty(_countryCodeNameMap, "JO", "Jordan"), _defineProperty(_countryCodeNameMap, "KZ", "Kazakhstan"), _defineProperty(_countryCodeNameMap, "KE", "Kenya"), _defineProperty(_countryCodeNameMap, "KI", "Kiribati"), _defineProperty(_countryCodeNameMap, "KP", "Korea, Democratic People's Republic of"), _defineProperty(_countryCodeNameMap, "KW", "Kuwait"), _defineProperty(_countryCodeNameMap, "KG", "Kyrgyzstan"), _defineProperty(_countryCodeNameMap, "LA", "Lao People's Democratic Republic"), _defineProperty(_countryCodeNameMap, "LV", "Latvia"), _defineProperty(_countryCodeNameMap, "LB", "Lebanon"), _defineProperty(_countryCodeNameMap, "LS", "Lesotho"), _defineProperty(_countryCodeNameMap, "LR", "Liberia"), _defineProperty(_countryCodeNameMap, "LY", "Libya"), _defineProperty(_countryCodeNameMap, "LI", "Liechtenstein"), _defineProperty(_countryCodeNameMap, "LT", "Lithuania"), _defineProperty(_countryCodeNameMap, "LU", "Luxembourg"), _defineProperty(_countryCodeNameMap, "MO", "Macao"), _defineProperty(_countryCodeNameMap, "MK", "Macedonia, the former Yugoslav Republic of"), _defineProperty(_countryCodeNameMap, "MG", "Madagascar"), _defineProperty(_countryCodeNameMap, "MW", "Malawi"), _defineProperty(_countryCodeNameMap, "MY", "Malaysia"), _defineProperty(_countryCodeNameMap, "MV", "Maldives"), _defineProperty(_countryCodeNameMap, "ML", "Mali"), _defineProperty(_countryCodeNameMap, "MT", "Malta"), _defineProperty(_countryCodeNameMap, "MH", "Marshall Islands"), _defineProperty(_countryCodeNameMap, "MQ", "Martinique"), _defineProperty(_countryCodeNameMap, "MR", "Mauritania"), _defineProperty(_countryCodeNameMap, "MU", "Mauritius"), _defineProperty(_countryCodeNameMap, "YT", "Mayotte"), _defineProperty(_countryCodeNameMap, "MX", "Mexico"), _defineProperty(_countryCodeNameMap, "FM", "Micronesia, Federated States of"), _defineProperty(_countryCodeNameMap, "MD", "Moldova, Republic of"), _defineProperty(_countryCodeNameMap, "MC", "Monaco"), _defineProperty(_countryCodeNameMap, "MN", "Mongolia"), _defineProperty(_countryCodeNameMap, "ME", "Montenegro"), _defineProperty(_countryCodeNameMap, "MS", "Montserrat"), _defineProperty(_countryCodeNameMap, "MA", "Morocco"), _defineProperty(_countryCodeNameMap, "MZ", "Mozambique"), _defineProperty(_countryCodeNameMap, "MM", "Myanmar"), _defineProperty(_countryCodeNameMap, "NA", "Namibia"), _defineProperty(_countryCodeNameMap, "NR", "Nauru"), _defineProperty(_countryCodeNameMap, "NP", "Nepal"), _defineProperty(_countryCodeNameMap, "NL", "Netherlands"), _defineProperty(_countryCodeNameMap, "NC", "New Caledonia"), _defineProperty(_countryCodeNameMap, "NI", "Nicaragua"), _defineProperty(_countryCodeNameMap, "NE", "Niger"), _defineProperty(_countryCodeNameMap, "NG", "Nigeria"), _defineProperty(_countryCodeNameMap, "NU", "Niue"), _defineProperty(_countryCodeNameMap, "NF", "Norfolk Island"), _defineProperty(_countryCodeNameMap, "MP", "Northern Mariana Islands"), _defineProperty(_countryCodeNameMap, "NO", "Norway"), _defineProperty(_countryCodeNameMap, "OM", "Oman"), _defineProperty(_countryCodeNameMap, "PK", "Pakistan"), _defineProperty(_countryCodeNameMap, "PW", "Palau"), _defineProperty(_countryCodeNameMap, "PS", "Palestinian Territory, Occupied"), _defineProperty(_countryCodeNameMap, "PA", "Panama"), _defineProperty(_countryCodeNameMap, "PG", "Papua New Guinea"), _defineProperty(_countryCodeNameMap, "PY", "Paraguay"), _defineProperty(_countryCodeNameMap, "PE", "Peru"), _defineProperty(_countryCodeNameMap, "PH", "Philippines"), _defineProperty(_countryCodeNameMap, "PN", "Pitcairn"), _defineProperty(_countryCodeNameMap, "PL", "Poland"), _defineProperty(_countryCodeNameMap, 'PT', "Portugal"), _defineProperty(_countryCodeNameMap, "PR", "Puerto Rico"), _defineProperty(_countryCodeNameMap, "QA", "Qatar"), _defineProperty(_countryCodeNameMap, "RE", "Réunion"), _defineProperty(_countryCodeNameMap, "RO", "Romania"), _defineProperty(_countryCodeNameMap, "RU", "Russian Federation"), _defineProperty(_countryCodeNameMap, "RW", "Rwanda"), _defineProperty(_countryCodeNameMap, "BL", "Saint Barthélemy"), _defineProperty(_countryCodeNameMap, "SH", "Saint Helena, Ascension and Tristan da Cunha"), _defineProperty(_countryCodeNameMap, "KN", "Saint Kitts and Nevis"), _defineProperty(_countryCodeNameMap, "LC", "Saint Lucia"), _defineProperty(_countryCodeNameMap, "MF", "Saint Martin (French part)"), _defineProperty(_countryCodeNameMap, "PM", "Saint Pierre and Miquelon"), _defineProperty(_countryCodeNameMap, "VC", "Saint Vincent and the Grenadines"), _defineProperty(_countryCodeNameMap, "WS", "Samoa"), _defineProperty(_countryCodeNameMap, "SM", "San Marino"), _defineProperty(_countryCodeNameMap, "ST", "Sao Tome and Principe"), _defineProperty(_countryCodeNameMap, "SA", "Saudi Arabia"), _defineProperty(_countryCodeNameMap, "SN", "Senegal"), _defineProperty(_countryCodeNameMap, "RS", "Serbia"), _defineProperty(_countryCodeNameMap, "SC", "Seychelles"), _defineProperty(_countryCodeNameMap, "SL", "Sierra Leone"), _defineProperty(_countryCodeNameMap, "SG", "Singapore"), _defineProperty(_countryCodeNameMap, "SX", "Sint Maarten (Dutch part)"), _defineProperty(_countryCodeNameMap, "SK", "Slovakia"), _defineProperty(_countryCodeNameMap, "SI", "Slovenia"), _defineProperty(_countryCodeNameMap, "SB", "Solomon Islands"), _defineProperty(_countryCodeNameMap, "SO", "Somalia"), _defineProperty(_countryCodeNameMap, "ZA", "South Africa"), _defineProperty(_countryCodeNameMap, "GS", "South Georgia and the South Sandwich Islands"), _defineProperty(_countryCodeNameMap, "SS", "South Sudan"), _defineProperty(_countryCodeNameMap, 'ES', "Spain"), _defineProperty(_countryCodeNameMap, "LK", "Sri Lanka"), _defineProperty(_countryCodeNameMap, "SD", "Sudan"), _defineProperty(_countryCodeNameMap, "SR", "Suriname"), _defineProperty(_countryCodeNameMap, "SJ", "Svalbard and Jan Mayen"), _defineProperty(_countryCodeNameMap, "SZ", "Swaziland"), _defineProperty(_countryCodeNameMap, "SE", "Sweden"), _defineProperty(_countryCodeNameMap, "CH", "Switzerland"), _defineProperty(_countryCodeNameMap, "SY", "Syrian Arab Republic"), _defineProperty(_countryCodeNameMap, "TW", "Taiwan, Province of China"), _defineProperty(_countryCodeNameMap, "TJ", "Tajikistan"), _defineProperty(_countryCodeNameMap, "TZ", "Tanzania, United Republic of"), _defineProperty(_countryCodeNameMap, "TH", "Thailand"), _defineProperty(_countryCodeNameMap, "TL", "Timor-Leste"), _defineProperty(_countryCodeNameMap, "TG", "Togo"), _defineProperty(_countryCodeNameMap, "TK", "Tokelau"), _defineProperty(_countryCodeNameMap, "TO", "Tonga"), _defineProperty(_countryCodeNameMap, "TT", "Trinidad and Tobago"), _defineProperty(_countryCodeNameMap, "TN", "Tunisia"), _defineProperty(_countryCodeNameMap, "TR", "Turkey"), _defineProperty(_countryCodeNameMap, "TM", "Turkmenistan"), _defineProperty(_countryCodeNameMap, "TC", "Turks and Caicos Islands"), _defineProperty(_countryCodeNameMap, "TV", "Tuvalu"), _defineProperty(_countryCodeNameMap, "UG", "Uganda"), _defineProperty(_countryCodeNameMap, "UA", "Ukraine"), _defineProperty(_countryCodeNameMap, "AE", "United Arab Emirates"), _defineProperty(_countryCodeNameMap, "UM", "United States Minor Outlying Islands"), _defineProperty(_countryCodeNameMap, "UY", "Uruguay"), _defineProperty(_countryCodeNameMap, "UZ", "Uzbekistan"), _defineProperty(_countryCodeNameMap, "VU", "Vanuatu"), _defineProperty(_countryCodeNameMap, "VE", "Venezuela, Bolivarian Republic of"), _defineProperty(_countryCodeNameMap, "VN", "Viet Nam"), _defineProperty(_countryCodeNameMap, "VG", "Virgin Islands, British"), _defineProperty(_countryCodeNameMap, "VI", "Virgin Islands, U.S."), _defineProperty(_countryCodeNameMap, "WF", "Wallis and Futuna"), _defineProperty(_countryCodeNameMap, "EH", "Western Sahara"), _defineProperty(_countryCodeNameMap, "YE", "Yemen"), _defineProperty(_countryCodeNameMap, "ZM", "Zambia"), _defineProperty(_countryCodeNameMap, "ZW", "Zimbabwe"), _countryCodeNameMap);

    var dealerListEl = document.getElementById('DealersList');

    window.initializeDealerMap = function () {
        bounds = new google.maps.LatLngBounds();
        mapOptions = {
            mapTypeId: 'roadmap'
        };

        // Display a map on the page
        map = new google.maps.Map(document.getElementById("FindDealerMap"), mapOptions);
        map.setTilt(45);

        map.setCenter(new google.maps.LatLng(51.5285578, -0.2420223));
        map.setZoom(14);

        var event = new CustomEvent('DealerMapLoaded');
        document.dispatchEvent(event);
    };

    function clearRenderedMarkers() {
        if (typeof google == 'undefined') return;
        for (var i = 0; i < renderedMarkers.length; i++) {
            renderedMarkers[i].setMap(null);
        }
        renderedMarkers = [];
        bounds = new google.maps.LatLngBounds();
    }

    function placeMarkers(markers, infoWindowContent) {

        if (typeof google == 'undefined') return;

        // Display multiple markers on a map
        var marker = null;

        // Loop through our array of markers & place each one on the map  
        for (var i = 0; i < markers.length; i++) {
            var position = new google.maps.LatLng(markers[i][2], markers[i][3]);
            bounds.extend(position);
            marker = new google.maps.Marker({
                position: position,
                map: map,
                title: markers[i][1],
                id: markers[i][0]
            });

            renderedMarkers.push(marker);

            google.maps.event.addListener(marker, 'click', function (marker, i) {
                return function () {
                    var searchResultEl = document.getElementById('dealer-list-item-' + marker.id);
                    if (!searchResultEl) return;
                    var searchResultTitleEl = searchResultEl.getElementsByTagName('h4')[0] || null;
                    if (!searchResultTitleEl) return;
                    searchResultTitleEl.dispatchEvent(new Event('click', { bubbles: true }));
                };
            }(marker, i));

            map.fitBounds(bounds);
        }
    }

    function displayDealers(dealers, address, country) {

        clearRenderedMarkers();

        if (!Array.isArray(dealers) || dealers.length < 1) {

            dealerListEl.innerHTML = "";

            var noResultsMessageEl = document.createElement('div');
            noResultsMessageEl.classList.add('no-results-message');

            var countryName = countryCodeNameMap[country];

            noResultsMessageEl.innerText = '0 results found for ' + address + ' in ' + countryName + '. Please check your search and try again';

            dealerListEl.appendChild(noResultsMessageEl);
            return;
        }

        var markers = [];
        // Info Window Content
        var infoWindowContent = [];

        for (var i = 0; i < dealers.length; i++) {
            markers.push([dealers[i]._id, dealers[i].name, dealers[i].location.coordinates[1], dealers[i].location.coordinates[0]]);
        }

        placeMarkers(markers, null);

        displayDealersList(dealers);
    }

    document.addEventListener('click', function (e) {
        var dealerHeadingEL = e.target.matches('.dealer-list-item h4') ? e.target : DOMHelper.queryParentEl(e.target, '.dealer-list-item h4');
        var dealerInfoButtonEL = e.target.matches('.dealer-list-item .dealer-info') ? e.target : DOMHelper.queryParentEl(e.target, '.dealer-list-item .dealer-info');

        var el = dealerHeadingEL || dealerInfoButtonEL;

        if (el) {
            el.parentNode.classList.add('inner-active');

            var dealerData = JSON.parse(el.parentNode.dataset.dealerData);

            for (var i = 0; i < renderedMarkers.length; i++) {
                if (renderedMarkers[i].id != dealerData._id) continue;
                map.setZoom(18);
                map.panTo(renderedMarkers[i].position);
                break;
            }

            if (dealerListEl) {
                dealerListEl.parentNode.classList.add('display-inner-only');
            }

            document.documentElement.scrollTop = document.getElementById('DealersList').getBoundingClientRect().top;
        }
    });

    var dealerBackLink = document.querySelector('.dealer-back-link');

    if (dealerBackLink) {
        dealerBackLink.addEventListener('click', function (e) {
            e.preventDefault();
            dealerListEl.parentNode.classList.remove('display-inner-only');
            var activeDealerListItemEl = document.querySelector('.dealer-list-item.inner-active');
            if (activeDealerListItemEl) {
                activeDealerListItemEl.classList.remove('inner-active');
            }
            map.fitBounds(bounds);
        });
    }

    function displayDealersList(dealers) {

        if (!dealerListEl) return;

        dealerListEl.innerHTML = "";

        for (var i = 0; i < dealers.length; i++) {
            var tmplClone = dealerItemTmpl.content.cloneNode(true);

            var milesDistance = null;
            if (dealers[i].distance) {
                milesDistance = (dealers[i].distance / 1000 * 0.621371).toFixed(2);
            }

            tmplClone.children[0].setAttribute('data-dealer-data', JSON.stringify(dealers[i]));

            tmplClone.children[0].id = 'dealer-list-item-' + dealers[i]._id;

            tmplClone.querySelector('h4').innerText = dealers[i].name;
            tmplClone.querySelector('.address').innerText = dealers[i].address;

            if (typeof dealers[i].description == 'string' && dealers[i].description.length > 0) {
                tmplClone.querySelector('.description').innerHTML = dealers[i].description.replace(/\n/g, "<br/>");
            } else if (typeof dealers[i].closes_at == 'string' && dealers[i].closes_at.length > 0) {
                tmplClone.querySelector('.description').innerText = "Closes at: " + dealers[i].closes_at;
            }

            if (milesDistance) {
                tmplClone.querySelector('.distance .miles-amount').innerText = milesDistance;
            } else {
                tmplClone.children[0].classList.add('hide-distance');
            }

            var directionsUrl = "https://www.google.com/maps/dir/?api=1";

            if (address) {
                directionsUrl += "&origin=" + address + " " + country;
            }

            directionsUrl += "&destination=" + dealers[i].address;

            tmplClone.querySelector('.directions-url').href = directionsUrl;

            var email = typeof dealers[i].email == 'string' && dealers[i].email.length > 0 ? dealers[i].email : null;
            var telephone = typeof dealers[i].telephone == 'string' && dealers[i].telephone.length > 0 ? dealers[i].telephone : null;
            var website = typeof dealers[i].website == 'string' && dealers[i].website.length > 0 ? dealers[i].website : null;

            if (email) {
                var emailLinkEl = tmplClone.querySelector('.contact-info .email');
                emailLinkEl.href = "mailto:" + email;
                emailLinkEl.innerText = email;
            }

            if (telephone) {
                var telLinkEl = tmplClone.querySelector('.contact-info .phone-number');
                telLinkEl.href = "tel:" + telephone.replace(/\s+/g, '');
                telLinkEl.innerText = telephone;
            }

            if (website) {
                var websiteLinkEl = tmplClone.querySelector('.contact-info .website');
                websiteLinkEl.href = website;
                websiteLinkEl.innerText = website.replace(/https:\/\/|http:\/\//g, '');
            }

            dealerListEl.appendChild(tmplClone);
        }
    }

    document.addEventListener("DealerMapLoaded", function (event) {

        if (!findADealerForm) return;

        var countryFieldEl = findADealerForm.querySelector('input[name="country"]');
        var locationFieldEl = findADealerForm.querySelector('input[name="location"]');

        var getDealersByCurrentPosition = function getDealersByCurrentPosition(position) {
            $.ajax({
                method: 'GET',
                url: 'https://site-apps.muttmotorcycles.com/dealer-search/reverse',
                headers: {
                    'Content-Type': 'application/json'
                },
                dataType: 'json',
                data: {
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude
                },
                success: function success(response) {
                    locationFieldEl.value = response.address.formatted_address;
                    countryFieldEl.value = response.address.country_code;
                    countryFieldEl.nextElementSibling.innerHTML = countryCodeNameMap[response.address.country_code];
                    displayDealers(response.dealers, address);
                },
                error: function error(_error) {
                    console.error(_error);
                }
            });
        };

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(getDealersByCurrentPosition);
        } else {
            x.innerHTML = "Geolocation is not supported by this browser.";
        }

        $.ajax({
            method: 'GET',
            url: 'https://site-apps.muttmotorcycles.com/dealer-search/all',
            headers: {
                'Content-Type': 'application/json'
            },
            dataType: 'json',
            success: function success(response) {
                for (var i = 0; i < response.dealers.length; i++) {
                    var dropdownOptionEl = document.querySelector('#CountrySelectOptions li[data-value="' + response.dealers[i].country + '"]');
                    if (!dropdownOptionEl) continue;
                    if (dropdownOptionEl.classList.contains('show')) continue;
                    dropdownOptionEl.classList.add('show');
                }
                displayDealers(response.dealers, address);
            },
            error: function error(_error2) {
                console.error(_error2);
            }
        });

        findADealerForm.addEventListener('submit', function (e) {
            e.preventDefault();

            var reqData = {};

            if (locationFieldEl && locationFieldEl.value.trim().length > 0) {
                reqData.address = locationFieldEl.value;
            }

            if (countryFieldEl && countryFieldEl.value.trim().length > 0) {
                reqData.country = countryFieldEl.value;
            }

            /* Make GET request to stockist search api with postcode */
            $.ajax({
                method: 'GET',
                url: 'https://site-apps.muttmotorcycles.com/dealer-search',
                headers: {
                    'Content-Type': 'application/json'
                },
                dataType: 'json',
                data: reqData,
                success: function success(response) {

                    /* Cache results to stop unneccessary requests */
                    window.sessionStorage.dealerSearch = JSON.stringify({
                        address: reqData.address,
                        country: reqData.country,
                        results: response
                    });

                    displayDealers(response.dealers, reqData.address, reqData.country);
                },
                error: function error(_error3) {
                    console.error(_error3);
                }
            });
        });
    });

    var countrySelectorButton = document.getElementById('CountrySelectToggle');

    if (countrySelectorButton) {

        document.addEventListener('click', function (e) {

            if (!countrySelectorButton.parentNode.classList.contains('open')) {

                if (DOMHelper.isNodeOrIsChildOfNode(e.target, countrySelectorButton)) {
                    countrySelectorButton.parentNode.classList.add('open');
                }
            } else {
                countrySelectorButton.parentNode.classList.remove('open');
            }
        });
    }

    var countrySelectEl = document.getElementById('CountrySelectOptions');

    if (countrySelectEl) {

        for (var i = 0; i < countrySelectEl.children.length; i++) {
            countrySelectEl.children[i].addEventListener('click', function () {
                if (countryFieldEl) {
                    countryFieldEl.value = this.dataset.value;
                    countryFieldEl.dispatchEvent(new Event('change'));
                }
                if (countrySelectorButton) {
                    countrySelectorButton.innerText = this.innerHTML;
                }
            });
        }

        var countryFieldEl = document.querySelector('input[name="country"]');
        countryFieldEl.addEventListener('change', function () {
            findADealerForm.dispatchEvent(new Event('submit'));
        });
    }
})();
'use strict';

(function () {

    var findOutMoreEl = document.getElementById('FindOutMore');

    if (!findOutMoreEl) return;

    var findOutMoreToggle = findOutMoreEl.getElementsByClassName('find-out-more-toggle')[0] || null;

    if (findOutMoreToggle) {
        findOutMoreToggle.addEventListener('click', function () {
            findOutMoreEl.classList.add('open');
        });
    }

    var findOutMoreCloseBtn = document.getElementById('FindOutMoreClose');

    if (findOutMoreCloseBtn) {
        findOutMoreCloseBtn.addEventListener('click', function (e) {
            e.preventDefault();
            findOutMoreEl.classList.remove('open');
        });
    }
})();
'use strict';

(function () {

    var footerContactFormEl = document.getElementById('mc-embedded-subscribe-form');

    if (!footerContactFormEl) return;

    var footerContactFormInputEls = footerContactFormEl.querySelectorAll('input');

    footerContactFormEl.addEventListener('submit', function (e) {

        var hasErrors = false;

        for (var i = 0; i < footerContactFormInputEls.length; i++) {
            if (footerContactFormInputEls[i].value.trim() < 1) {
                hasErrors = true;
                footerContactFormInputEls[i].parentNode.children[1].innerHTML = "Field is required";
                footerContactFormInputEls[i].parentNode.classList.add('field-error');
            }
        }

        if (!hasErrors) return;

        e.preventDefault();
    });

    var onInputChange = function onInputChange() {
        for (var i = 0; i < footerContactFormInputEls.length; i++) {
            if (!footerContactFormInputEls[i].parentNode.classList.contains('field-error')) continue;
            footerContactFormInputEls[i].parentNode.classList.remove('field-error');
        }
    };

    for (var i = 0; i < footerContactFormInputEls.length; i++) {
        footerContactFormInputEls[i].addEventListener('input', onInputChange);
    }
})();
'use strict';

(function () {

    var garageCompareEl = document.getElementById('GarageCompare');

    if (!garageCompareEl) return;

    var garageCompareListEl = document.getElementById('GarageCompareList');

    var garageCompareOpts = document.querySelectorAll('.bike-product-card input[name="compare"]');

    var garageItemsCount = 0;

    for (var i = 0; i < garageCompareOpts.length; i++) {
        garageCompareOpts[i].addEventListener('change', function () {

            if (this.checked) {
                var clone = this.parentNode.parentNode.cloneNode(true);

                if (clone.dataset.specTableId) {
                    var specTableEl = document.createElement('div');
                    specTableEl.setAttribute('class', 'bike-specifications-table');
                    specTableEl.setAttribute('data-spec-table-id', clone.dataset.specTableId);

                    var removeBtnEl = document.createElement('button');
                    removeBtnEl.setAttribute('class', 'remove-btn');
                    removeBtnEl.addEventListener('click', function (e) {
                        e.preventDefault();removeFromCompareList(this);
                    });

                    clone.appendChild(specTableEl);
                    clone.appendChild(removeBtnEl);
                }

                garageCompareListEl.prepend(clone);
                garageItemsCount++;
                garageCompareListEl.scrollLeft = 0;
                window.renderSpecifcationTables();
            } else {

                var elToRemove = garageCompareListEl.querySelector('.bike-product-card[data-handle="' + this.parentNode.parentNode.dataset.handle + '"]');

                if (elToRemove) {
                    elToRemove.parentNode.removeChild(elToRemove);
                    garageItemsCount--;
                }
            }

            if (garageItemsCount < 1) {
                garageCompareEl.classList.add('hide');
            } else {
                if (garageItemsCount < 2) {
                    garageCompareEl.classList.add('single-bike');
                } else {
                    garageCompareEl.classList.remove('single-bike');
                }
                garageCompareEl.classList.remove('hide');
            }

            window.initialiseScrollingDotIndicators('.customer-garage-page .js-scrolling-dot-indicator', true);
        });
    }

    var showMoreSpecsBtn = document.getElementById('SpecsShowMoreBtn');

    if (showMoreSpecsBtn) {
        showMoreSpecsBtn.addEventListener('click', function () {
            if (garageCompareEl.classList.contains('show-all-specs')) {
                garageCompareEl.classList.remove('show-all-specs');
            } else {
                garageCompareEl.classList.add('show-all-specs');
            }
        });
    }

    document.addEventListener('renderedspecificationtable', function (e) {

        if (!DOMHelper.queryParentEl(e.detail.el, '#GarageCompare')) return;

        var specRowEls = e.detail.el.getElementsByClassName('bike-specifications-table__row');

        for (var _i = 0; _i < specRowEls.length; _i++) {
            specRowEls[_i].addEventListener('click', function () {

                console.log('click');

                if (this.classList.contains('compare-spec')) {
                    this.classList.remove('compare-spec');
                    return;
                }

                var existingCompareSpecRowEl = garageCompareEl.querySelector('.bike-specifications-table__row.compare-spec');

                if (existingCompareSpecRowEl) {
                    existingCompareSpecRowEl.classList.remove('compare-spec');
                }

                this.classList.add('compare-spec');
            });
        }
    });

    function removeFromCompareList(el) {

        var handle = el.parentNode.dataset.handle;

        if (handle) {
            var input = document.querySelector('.garage-bikes .bike-product-card[data-handle="' + handle + '"] input[name="compare"]');
            if (input) {
                input.click();
            }
        }
    }
})();
'use strict';

(function () {

    document.addEventListener('click', function (e) {
        var el = e.target.matches('[data-add-to-garage]') ? e.target : DOMHelper.queryParentEl(e.target, '[data-add-to-garage]');

        if (!el) return;

        e.preventDefault();

        if (!cake.customer_id) {
            window.displayInfoPopup('GarageLoginPrompt');
            return;
        }

        var product_handle = el.getAttribute('data-add-to-garage');
        var action = el.classList.contains('added') ? 'remove' : 'add';

        if (action == 'add') {
            el.classList.add('added');
        } else {
            el.classList.remove('added');
        }

        var formData = new FormData();

        formData.append('action', action);
        formData.append('customer_id', cake.customer_id);
        formData.append('product_handle', product_handle);

        fetch('https://garage.muttmotorcycles.com/garage.php', {
            method: 'POST',
            headers: { 'X-Security-Token': cake.customer_api_token },
            body: formData
        }).then(function (response) {
            return response.json();
        }).then(function (response) {

            document.dispatchEvent(new CustomEvent('updatedGarage', {
                detail: {
                    action: action,
                    product_handle: product_handle
                }
            }));
        }).catch(function (err) {
            console.log(err);
            alert('There was an error adding to garage');

            if (action == 'add') {
                el.classList.remove('added');
            } else {
                el.classList.add('added');
            }
        });
    });
})();

(function () {

    document.addEventListener('updatedGarage', function (e) {

        var query = '[data-add-to-garage="' + e.detail.product_handle + '"]';

        if (e.detail.action == 'add') {
            query += ":not(.added)";
        } else {
            query += ".added";
        }

        var btns = document.querySelectorAll(query);

        for (var i = 0; i < btns.length; i++) {
            if (e.detail.action == 'add') {
                btns[i].classList.add('added');
            } else {
                btns[i].classList.remove('added');
            }
        }

        var customerGarageOverviewEls = document.querySelectorAll('.customer-garage-overview');

        if (customerGarageOverviewEls.length > 0) {

            fetch('/pages/your-garage?view=customer-garage-overview-content').then(function (response) {
                return response.text();
            }).then(function (response) {
                for (var _i = 0; _i < customerGarageOverviewEls.length; _i++) {
                    customerGarageOverviewEls[_i].querySelector('.scrolling-products__products').innerHTML = response.split('<!--__BEGIN_CUSTOMER_GARAGE_CONTENT__-->').pop().split('<!--__END_CUSTOMER_GARAGE_CONTENT__-->')[0].trim();
                }
            });
        }

        if (e.detail.action == 'remove') {
            var customerGarageBikesListEl = document.querySelector('.customer-garage-page .garage-bikes');

            if (customerGarageBikesListEl) {
                var bikeCardEls = document.querySelectorAll('.bike-product-card[data-handle=' + e.detail.product_handle + ']');

                for (var _i2 = 0; _i2 < bikeCardEls.length; _i2++) {
                    bikeCardEls[_i2].parentNode.removeChild(bikeCardEls[_i2]);
                }
            }
        }
    });
})();
'use strict';

(function () {
    $('.header-carousel__slider').slick({
        adaptiveHeight: true,
        nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="32" viewBox="0 0 16 32"><path id="Path_1500" data-name="Path 1500" d="M3493.329,89.45a.506.506,0,0,1-.218-.05l-15.5-7.5a.5.5,0,0,1-.282-.45v-7.5a.5.5,0,0,1,.718-.45l15.282,7.394,15.282-7.394a.5.5,0,0,1,.718.45v7.5a.5.5,0,0,1-.282.45l-15.5,7.5A.953.953,0,0,1,3493.329,89.45Z" transform="translate(-73.449 3509.329) rotate(-90)" fill="#5f5f5f"/></svg></button>',
        prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="32" viewBox="0 0 16 32"><path id="Path_1501" data-name="Path 1501" d="M3493.329,89.45a.506.506,0,0,1-.218-.05l-15.5-7.5a.5.5,0,0,1-.282-.45v-7.5a.5.5,0,0,1,.718-.45l15.282,7.394,15.282-7.394a.5.5,0,0,1,.718.45v7.5a.5.5,0,0,1-.282.45l-15.5,7.5A.5.5,0,0,1,3493.329,89.45Z" transform="translate(89.449 -3477.329) rotate(90)" fill="#5f5f5f"/></svg></button>',
        dots: true,
        responsive: [{
            breakpoint: 990,
            settings: {
                arrows: false,
                dots: true
            }
        }]
    });
})();
'use strict';

(function () {
    var siteHeaderEl = document.querySelector('.site-header');
    var headerSectionEl = document.querySelector('.header-section');
    var miniHeaderEl = document.querySelector('.mini-header');

    if (!siteHeaderEl) return;

    var pageHeaderHeight = siteHeaderEl.clientHeight;
    var ticking = false;

    window.addEventListener('scroll', function () {

        if (ticking) return;

        window.requestAnimationFrame(function () {
            ticking = false;
        });

        if (document.documentElement.scrollTop > pageHeaderHeight + 2) {
            miniHeaderEl.classList.add('active');
            headerSectionEl.classList.add('header-up');
        } else {
            miniHeaderEl.classList.remove('active');
            headerSectionEl.classList.remove('header-up');
        }

        ticking = true;
    });

    miniHeaderEl.addEventListener('click', function () {
        headerSectionEl.classList.remove('header-up');
    });
})();

function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
    var dc = document.cookie;
    var prefix = name + "=";
    var begin = dc.indexOf("; " + prefix);
    if (begin == -1) {
        begin = dc.indexOf(prefix);
        if (begin != 0) return null;
    } else {
        begin += 2;
        var end = document.cookie.indexOf(";", begin);
        if (end == -1) {
            end = dc.length;
        }
    }
    // because unescape has been deprecated, replaced with decodeURI
    //return unescape(dc.substring(begin + prefix.length, end));
    return decodeURI(dc.substring(begin + prefix.length, end));
}

$('.close-announcement').click(function () {
    $('.announcement-bar').addClass('hide');
    setCookie('announcement', 'hide', 7);
});

$(document).ready(function () {

    var announcementHide = getCookie("announcement");
    if (announcementHide !== null) {
        $('.announcement-bar').addClass('hide');
    }
});
"use strict";

$(".html-video-area").each(function () {
  var e = $(this),
      n = $(this).find("#video-element"),
      t = $(this).find(".video-controls"),
      o = ($(this).find(".bottom-wrapper"), $(this).find(".progress-bar")),
      a = $(this).find(".time-bar"),
      s = $(this).find(".buffer-bar"),
      u = $(".play-button"),
      i = $(this).find(".sound-button"),
      r = $(this).find(".volume"),
      d = $(this).find(".volume-bar"),
      c = $(this).find(".btnFS"),
      l = $(this).find(".current"),
      m = $(this).find(".duration"),
      f = $(this).find("#fastFwd");function p() {
    n[0].paused ? (n[0].play(), t.addClass("playing"), u.addClass("playing"), e.parents(".video-header").length && e.parents(".video-header").addClass("playing")) : (n[0].pause(), t.removeClass("playing"), u.removeClass("playing"), e.parents(".video-header").removeClass("playing"));
  }function h(e, t) {
    $percentage = t ? 100 * t : ($position = e - r.offset().left, 100 * $position / r.width()), 100 < $percentage && ($percentage = 100), $percentage < 0 && ($percentage = 0), d.css("width", $percentage + "%"), n[0].volume = $percentage / 100, 0 == n[0].volume ? i.removeClass("sound-med").addClass("sound-muted") : .5 < n[0].volume ? i.removeClass("sound-muted").addClass("sound-med") : i.removeClass("sound-muted").removeClass("sound-med");
  }function g(e) {
    var t = Math.floor(e / 60) < 10 ? "0" + Math.floor(e / 60) : Math.floor(e / 60);return t + ":" + (Math.floor(e - 60 * t) < 10 ? "0" + Math.floor(e - 60 * t) : Math.floor(e - 60 * t));
  }function v() {
    $current_buffer = n[0].buffered.end(0), $max_duration = n[0].duration, $perc = 100 * $current_buffer / $max_duration, s.css("width", $perc + "%"), $current_buffer < $max_duration && setTimeout(v, 500);
  }function b(e) {
    $position = e - a.offset().left, $percentage = 100 * $position / o.width(), 100 < $percentage && ($percentage = 100), $percentage < 0 && ($percentage = 0), a.css("width", $percentage + "%"), n[0].currentTime = n[0].duration * $percentage / 100;
  }n.on("loadedmetadata", function () {
    l.text(g(0)), m.text(g(n[0].duration)), h(0, .7), setTimeout(v, 150);
  }), n.click(function () {
    p();
  }), n.on("timeupdate", function () {
    l.text(g(n[0].currentTime)), m.text(g(n[0].duration));n[0].currentTime, n[0].duration;var e = 100 * n[0].currentTime / n[0].duration;a.css("width", e + "%");
  }), e.on("mouseleave", function () {
    !1 === n[0].paused && e.addClass("playing");
  }), e.on("mouseover", function () {}), u.click(function () {
    p();
  }), f.click(function () {
    1 === n[0].playbackRate ? (n[0].playbackRate = 2, f.text("2x Speed")) : 2 === n[0].playbackRate && (n[0].playbackRate = 1, f.text("1x Speed"));
  });var C = !1;r.on("mousedown", function (e) {
    C = !0, n[0].muted = !1, i.removeClass("muted"), h(e.pageX);
  }), $(document).on("mouseup", function (e) {
    C && (C = !1, h(e.pageX));
  }), $(document).on("mousemove", function (e) {
    C && h(e.pageX);
  }), i.click(function () {
    n[0].muted = !n[0].muted, $(this).toggleClass("sound-muted"), n[0].muted ? d.css("width", 0) : d.css("width", 100 * n[0].volume + "%");
  }), c.click(function () {
    n[0].requestFullscreen ? n[0].requestFullscreen() : n[0].mozRequestFullScreen ? n[0].mozRequestFullScreen() : n[0].webkitRequestFullscreen ? n[0].webkitRequestFullscreen() : n[0].msRequestFullscreen && n[0].msRequestFullscreen();
  });var w = !1;o.on("mousedown", function (e) {
    w = !0, b(e.pageX);
  }), $(document).on("mouseup", function (e) {
    w && (w = !1, b(e.pageX));
  }), $(document).on("mousemove", function (e) {
    w && b(e.pageX);
  });
});
'use strict';

window.displayInfoPopup = function (id) {
    var infoPopupEl = document.getElementById(id);
    if (!infoPopupEl) return;
    infoPopupEl.classList.add('active');
};

window.hideInfoPopup = function (id) {
    var infoPopupEl = document.getElementById(id);
    if (!infoPopupEl) return;
    infoPopupEl.classList.remove('active');
};
'use strict';

/*============================*/
/* Update main product image. */
/*============================*/
var switchImage = function switchImage(newImageSrc, newImage, mainImageDomEl) {
    // newImageSrc is the path of the new image in the same size as originalImage is sized.
    // newImage is Shopify's object representation of the new image, with various attributes, such as scr, id, position.
    // mainImageDomEl is the passed domElement, which has not yet been manipulated. Let's manipulate it now.
    jQuery(mainImageDomEl).parents('a').attr('href', newImageSrc.replace('_grande', '_1024x1024'));
    jQuery(mainImageDomEl).attr('src', newImageSrc);
};

jQuery(function ($) {

    /* Placeholder JS */
    /*==========================*/
    var test = document.createElement('input');
    if (!('placeholder' in test)) {
        $('[placeholder]').each(function () {
            if ($(this).val() === '') {
                var hint = $(this).attr('placeholder');
                $(this).val(hint).addClass('hint');
            }
        });
        $('[placeholder]').focus(function () {
            if ($(this).val() === $(this).attr('placeholder')) {
                $(this).val('').removeClass('hint');
            }
        }).blur(function () {
            if ($(this).val() === '') {
                $(this).val($(this).attr('placeholder')).addClass('hint');
            }
        });
    }

    /* Form validation JS */
    /*==========================*/

    $('input.error, textarea.error').focus(function () {
        $(this).removeClass('error');
    });

    $('form :submit').click(function () {
        $(this).parents('form').find('input.hint, textarea.hint').each(function () {
            $(this).val('').removeClass('hint');
        });
        return true;
    });

    /* Remove SVG images to avoid broken images in all browsers that don't support SVG. */
    /*==========================*/

    var supportsSVG = function supportsSVG() {
        return document.implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#Image', '1.1');
    };
    if (!supportsSVG()) {
        $('img[src*=".svg"]').remove();
    }

    /* Prepare to have floated images fill the width of the design on blog pages on small devices. */
    /*==========================*/

    var images = $('.article img').load(function () {
        var src = $(this).attr('src').replace(/_grande\.|_large\.|_medium\.|_small\./, '.');
        var width = $(this).width();
        $(this).attr('src', src).attr('width', width).removeAttr('height');
    });

    /* Update main product image when a thumbnail is clicked. */
    /*==========================*/
    $('.product-photo-thumb a').on('click', function (e) {
        e.preventDefault();
        switchImage($(this).attr('href'), null, $('.product-photo-container img')[0]);
    });
});
'use strict';

(function () {

    var menuItemEls = document.querySelectorAll('.header-menu .site-nav .menu-item');
    var siteNavEl = document.querySelector('.header-menu .site-nav');
    var currentHoveredEl = null;
    var currentOpenEl = null;
    var currentTimeout = null;

    for (var i = 0; i < menuItemEls.length; i++) {
        menuItemEls[i].addEventListener('mouseover', function () {

            if (!this.classList.contains('dropdown')) {
                return;
            }

            this.classList.add('mouse-over');

            if (currentOpenEl && !currentOpenEl.isEqualNode(this)) {
                currentOpenEl.classList.remove('mouse-over');
            }

            currentOpenEl = this;
            currentHoveredEl = this;
        });
    }

    if (siteNavEl) {
        siteNavEl.addEventListener('mouseout', function () {

            if (currentHoveredEl) {
                currentHoveredEl = null;
            }

            if (currentTimeout) {
                clearTimeout(currentTimeout);
            }

            currentTimeout = setTimeout(function () {

                currentTimeout = null;

                if (currentOpenEl && !currentHoveredEl) {

                    var openProductMenuElements = document.querySelectorAll('.product-menu-sidebar .product-menu.active, .product-menu-content-wrap .product-menu-content.active');

                    for (var _i = 0; _i < openProductMenuElements.length; _i++) {
                        openProductMenuElements[_i].classList.remove('active');
                    }

                    currentOpenEl.classList.remove('mouse-over');
                    currentOpenEl = null;
                }
            }, 1500);
        });
    }
})();
"use strict";

jQuery(function ($) {
    $(".dynamic-menu").each(function () {
        var container = $(this).attr('data-wrap');
        $(".dynamic-menu[data-wrap='" + container + "'] li.menu-tab").mouseover(function () {
            var cat_id = $(this).attr('data-menu');

            $(".dynamic-menu[data-wrap='" + container + "'] li.menu-tab").removeClass('current');
            $(".dynamic-menu[data-wrap='" + container + "'] .dynamic-menu-container .dynamic-menu-content").removeClass('current');

            $("li.menu-tab[data-menu='" + cat_id + "']").addClass('current');
            $("#" + cat_id).addClass('current');
        });
    });

    $(".dynamic-three-tier-menu").each(function () {
        var container = $(this).attr('data-tier-wrap');
        $(".dynamic-three-tier-menu[data-tier-wrap='" + container + "'] li.menu-level-two").mouseover(function () {
            var cat_id = $(this).attr('data-tier-menu');

            $(".dynamic-three-tier-menu[data-tier-wrap='" + container + "'] li.menu-level-two").removeClass('current');
            $(".dynamic-three-tier-menu[data-tier-wrap='" + container + "'] .dynamic-three-tier-menu-container .dynamic-three-tier-menu-content").removeClass('current');

            $("li.menu-level-two[data-tier-menu='" + cat_id + "']").addClass('current');
            $(".dynamic-three-tier-menu[data-tier-wrap='" + container + "'] #" + cat_id).addClass('current');
        });
    });

    $(".dynamic-three-tier-menu-content").each(function () {
        var container = $(this).attr('data-product-wrap');

        $(".dynamic-three-tier-menu-content[data-product-wrap='" + container + "'] li.product-menu").mouseover(function () {
            var cat_id = $(this).attr('data-product');

            $(".dynamic-three-tier-menu-content[data-product-wrap='" + container + "'] li.product-menu").removeClass('active');
            $(".dynamic-three-tier-menu-content[data-product-wrap='" + container + "'] .product-menu-content").removeClass('active');

            $("li.product-menu[data-product='" + cat_id + "']").addClass('active');
            $(".dynamic-three-tier-menu-content[data-product-wrap='" + container + "'] [data-product='" + cat_id + "']").addClass('active');
            // $("#"+cat_id).addClass('active');
        });
    });

    $(".menu-item").mouseleave(function () {
        $(".dynamic-three-tier-menu-content").each(function () {
            $(this).removeClass('current');
        });
    });
});
'use strict';

(function () {
    var parallaxHeaderImageEls = document.querySelectorAll('.cb-header-image.parallax');

    var displayParallaxBGImages = function displayParallaxBGImages() {
        for (var i = 0; i < parallaxHeaderImageEls.length; i++) {
            if (window.innerWidth < 750 && parallaxHeaderImageEls[i].dataset.mobileBgImageUrl) {
                parallaxHeaderImageEls[i].style.backgroundImage = 'url(\'' + parallaxHeaderImageEls[i].dataset.mobileBgImageUrl + '\')';
            } else {
                parallaxHeaderImageEls[i].style.backgroundImage = 'url(\'' + parallaxHeaderImageEls[i].dataset.desktopBgImageUrl + '\')';
            }
        }
    };

    if (parallaxHeaderImageEls.length > 0) {
        window.addEventListener('resize', displayParallaxBGImages);
        displayParallaxBGImages();
    }
})();
'use strict';

(function () {

    var partProductSelectEl = document.getElementById('ProductSelect-Part');

    if (!partProductSelectEl) return;
    if (typeof _current_product == 'undefined') return;

    var onVariantSelected = function onVariantSelected(variant, selector) {
        console.log(variant);
        if (!variant) return;
        window.history.replaceState(null, document.title, '?variant=' + variant.id);
    };

    new Shopify.OptionSelectors('ProductSelect-Part', { product: _current_product, onVariantSelected: onVariantSelected });
})();
'use strict';

(function () {
    var partsSearchFormEl = document.getElementById('PartsSearchForm');

    if (!partsSearchFormEl) return;

    var searchTermInputEl = partsSearchFormEl.querySelector('input[name="term"]');
    var tagContraintInputEl = partsSearchFormEl.querySelector('input[name="constraint"]');

    if (searchTermInputEl) {
        searchTermInputEl.addEventListener('input', function () {
            if (!tagContraintInputEl) return;
            var searchTermHandle = this.value.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '').replace(/--/g, '-');
            tagContraintInputEl.value = searchTermHandle;
            //tagContraintInutEl.setAttribute('value', searchTermHandle);
        });
    }
})();
'use strict';

(function () {

    var shareProduct = null;

    document.addEventListener('click', function (e) {
        var el = e.target.matches('[data-social-share]') ? e.target : DOMHelper.queryParentEl(e.target, '[data-social-share]');

        if (!el) return;

        e.preventDefault();

        if (el.dataset.socialShareType == 'bike') {
            window.displayInfoPopup('BikeSocialShareWindow');
        } else {
            window.displayInfoPopup('ProductSocialShareWindow');
        }

        shareProduct = {
            title: el.dataset.title,
            url: el.dataset.socialShare
        };
    });

    var socialShareBtns = document.getElementsByClassName('social-share-btn');

    for (var i = 0; i < socialShareBtns.length; i++) {
        socialShareBtns[i].addEventListener('click', function (e) {

            e.preventDefault();

            var url = null;

            if (this.classList.contains('facebook')) {
                url = "http://www.facebook.com/share.php?u=" + shareProduct.url + "&title=" + shareProduct.title;
            } else if (this.classList.contains('twitter')) {
                url = "http://twitter.com/intent/tweet?text=" + shareProduct.title + "+" + shareProduct.url;
            } else if (this.classList.contains('email')) {
                url = "mailto:?subject=" + shareProduct.title + "+ &body=Check this out " + shareProduct.url;
            }

            if (!url) return;

            window.open(url);
        });
    }
})();
'use strict';

jQuery(function () {

    jQuery('.swatch :radio').change(function () {
        var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
        var optionValue = jQuery(this).val();

        jQuery(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
    });
});
$('.product__thumbs .product__thumb').click(function () {
    console.log('product single thumbnail clicked');
    $('html, body').animate({
        scrollTop: $($(this).attr('href')).offset().top
    }, 500);
    return false;
});
"use strict";

jQuery(function ($) {
  $(".recently-viewed").each(function () {
    var container = $(this).attr('data-view-wrap');
    $(".recently-viewed[data-view-wrap='" + container + "'] h2.tab").click(function () {
      var cat_id = $(this).attr('data-cat');

      $(".recently-viewed[data-view-wrap='" + container + "'] h2.tab").removeClass('current');
      $(".recently-viewed[data-view-wrap='" + container + "'] .block-content").removeClass('current');

      $("h2.tab[data-cat='" + cat_id + "']").addClass('current');
      $(".recently-viewed[data-view-wrap='" + container + "'] #" + cat_id).addClass('current');
    });
  });
});
'use strict';

(function () {

    if (document.body.id != 'account' && document.cookie.indexOf('redirect-to-garage') != -1) {
        //Clear redirect to garage cookie
        document.cookie = 'redirect-to-garage=1; expires=Thu, 1 January 1970 00:00:00 UTC; path=/;';
    }

    if (document.body.id == 'account' && document.body.classList.contains('template-customers-account') && document.cookie.indexOf('redirect-to-garage') != -1) {
        document.cookie = 'redirect-to-garage=1; expires=Thu, 1 January 1970 00:00:00 UTC; path=/;';
        window.location.href = '/pages/your-garage';
    }

    if (window.location.hash.indexOf('redirect-to-garage') != -1) {
        document.cookie = 'redirect-to-garage=1;path=/;';
    }
})();
"use strict";

var _dc_specificationTablePageMarkup = null;

window.extractSpecifcationTableMarkup = function (specTableId) {
    if (typeof specTableId != 'string') return null;
    var beginStr = "<!--__BEGIN_SPECIFICATION_TABLE_" + specTableId + "__-->";
    var endStr = "<!--__END_SPECIFICATION_TABLE_" + specTableId + "__-->";
    if (_dc_specificationTablePageMarkup.indexOf(beginStr) == -1 || _dc_specificationTablePageMarkup.indexOf(endStr) == -1) return null;
    return _dc_specificationTablePageMarkup.split(beginStr).pop().split(endStr)[0];
};

function specTableHideRowsOutOfRange(el, rowStart, rowEnd) {
    if (rowStart === null || rowEnd === null) return;
    if (isNaN(rowStart) || isNaN(rowEnd)) return;

    if (rowStart < rowEnd) {

        for (var j = 0; j < el.children.length; j++) {

            var rowNumber = j + 1;

            if (typeof el.children[j] == 'undefined') break;

            if (rowNumber < rowStart) {
                el.children[j].style.display = "none";
            }

            if (rowNumber > rowEnd) {
                el.children[j].style.display = "none";
            }
        }
    }
}

var displayTable = function displayTable(el) {

    if (el.previousSibling && el.previousSibling.tagName == "P" && el.previousSibling.innerText.trim().length < 1) {
        el.parentNode.removeChild(el.previousSibling);
    }

    var specTableId = el.dataset.specTableId;

    var rowStart = null;
    var rowEnd = null;

    if (typeof el.dataset.rowStart != 'undefined' && el.dataset.rowEnd != 'undefined') {
        rowStart = parseInt(el.dataset.rowStart);
        rowEnd = parseInt(el.dataset.rowEnd);
    }

    el.innerHTML = window.extractSpecifcationTableMarkup(specTableId);
    specTableHideRowsOutOfRange(el, rowStart, rowEnd);

    el.classList.add('rendered');

    document.dispatchEvent(new CustomEvent('renderedspecificationtable', { detail: { el: el } }));
};

window.renderSpecifcationTables = function () {

    var specificationTableEls = document.querySelectorAll('.bike-specifications-table[data-spec-table-id]:not(.rendered)');

    if (typeof _dc_specificationTablePageMarkup == 'string') {

        for (var i = 0; i < specificationTableEls.length; i++) {
            displayTable(specificationTableEls[i]);
        }

        return;
    }

    if (specificationTableEls.length > 0) {
        fetch('/pages/bike-specifications-editor').then(function (response) {
            return response.text();
        }).then(function (response) {

            _dc_specificationTablePageMarkup = response;

            for (var _i = 0; _i < specificationTableEls.length; _i++) {
                displayTable(specificationTableEls[_i]);
            }
        });
    }
};

(function () {
    window.renderSpecifcationTables();
})();
"use strict";

window.scrollTo = function (element, to, duration) {

    element.scrollTop = to;

    return;

    var start = element.scrollTop,
        change = to - start,
        currentTime = 0,
        increment = 20;

    var animateScroll = function animateScroll() {
        currentTime += increment;
        var val = Math.easeInOutQuad(currentTime, start, change, duration);
        element.scrollTop = val;
        if (currentTime < duration) {
            setTimeout(animateScroll, increment);
        }
    };
    animateScroll();
};

Math.easeInOutQuad = function (t, b, c, d) {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t + b;
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
};
'use strict';

var scrollTicking = false;

window.initialiseScrollingDotIndicators = function (selector, reinitialise) {

    if (typeof reinitialise != 'boolean') reinitialise = false;

    var scrollingDotIndicatorEls = [];

    if (typeof selector == 'string') {
        scrollingDotIndicatorEls = document.querySelectorAll(selector);
        console.log(scrollingDotIndicatorEls);
    } else {
        scrollingDotIndicatorEls = document.getElementsByClassName('js-scrolling-dot-indicator');
    }

    for (var i = 0; i < scrollingDotIndicatorEls.length; i++) {

        var scrollingDotIndicatorEl = scrollingDotIndicatorEls[i];

        if (scrollingDotIndicatorEl.classList.contains('initialised') && !reinitialise) continue;

        var scrollingElSelector = typeof scrollingDotIndicatorEl.dataset.siblingSelector != 'undefined' ? scrollingDotIndicatorEl.dataset.siblingSelector : null;

        if (!scrollingElSelector) continue;

        var scrollEl = scrollingDotIndicatorEl.parentNode.querySelector(scrollingElSelector);

        if (!scrollEl) continue;

        if (reinitialise) {
            scrollingDotIndicatorEl.innerHTML = "";
        }

        if (scrollEl.children.length < 1) continue;

        for (var j = 0; j < scrollEl.children.length; j++) {
            var dotEl = document.createElement('span');
            dotEl.classList.add('dot');

            if (j == 0) {
                dotEl.classList.add('active');
            }

            scrollingDotIndicatorEl.appendChild(dotEl);
        }

        scrollEl.addEventListener('scroll', function (e) {

            if (scrollTicking) return;

            var currentEl = this;

            var scrollingDotIndicator = currentEl.parentNode.querySelector('.js-scrolling-dot-indicator');

            window.requestAnimationFrame(function () {
                for (var i = 0; i < currentEl.children.length; i++) {
                    var currentChildCenterPoint = currentEl.children[i].offsetLeft + currentEl.children[i].clientWidth / 2;
                    var centerPointWithinRange = currentChildCenterPoint > currentEl.scrollLeft && currentChildCenterPoint < currentEl.scrollLeft + currentEl.clientWidth / 2 + 10;
                    var scrollEndReached = currentEl.scrollLeft + currentEl.clientWidth >= currentEl.scrollWidth;
                    if (scrollEndReached || centerPointWithinRange) {
                        if (scrollingDotIndicator.children[i].classList.contains('active')) continue;
                        scrollingDotIndicator.querySelector('.active').classList.remove('active');
                        scrollingDotIndicator.children[i].classList.add('active');
                    }
                }
                scrollTicking = false;
            });

            scrollTicking = true;
        });

        scrollingDotIndicatorEl.classList.add('initialised');
    }
};

window.initialiseScrollingDotIndicators();
'use strict';

var SearchAutoSuggest = {

    timeOut: null,

    query: function query(el) {

        var searchResultsElId = 'searchResults';

        if (window.outerWidth > 990) {
            searchResultsElId = 'searchResultsDesktop';
        }

        var searchTerm = el.value;
        var searchResultsEl = document.getElementById(searchResultsElId);

        if (searchTerm.length > 2) {

            if (SearchAutoSuggest.timeOut != null) {
                clearTimeout(SearchAutoSuggest.timeOut);
            }

            SearchAutoSuggest.timeOut = setTimeout(function () {
                SearchAutoSuggest.timeOut = null;

                SearchAutoSuggest.getQueryResults(searchTerm, function (html) {

                    // populate search results overlay
                    searchResultsEl.innerHTML = html;
                });
            }, 300);
        } else {
            searchResultsEl.innerHTML = '';
        }
    },

    getQueryResults: function getQueryResults(searchTerm, callback) {

        fetch('/search.liquid?q=' + searchTerm + '&view=autosuggest', {
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'text/html',
                'method': 'get'
            }
        }).then(function (data) {
            return data.text();
        }).then(function (data) {

            callback(data);
        }).catch(function (err) {
            /* uh oh, we have error. */
            console.error(err);
        });
    }
};
'use strict';

var SearchDesktop = {

    toggleView: function toggleView() {
        var htmlEl = document.documentElement;

        if (htmlEl.classList.contains('search-desktop--isVisible')) {
            // remove visible class to html element
            htmlEl.classList.remove('search-desktop--isVisible');
        } else {
            // add visible class to html element
            htmlEl.classList.add('search-desktop--isVisible');

            // focus on search input
            var searchDesktopInput = document.querySelectorAll('.search-desktop form input[type=text]')[0];
            searchDesktopInput.focus();
        }

        // prevent link going to page
        return false;
    }
};

(function () {

    var formInputEl = document.querySelector('.search-desktop__form input[type="text"]');

    if (!formInputEl) return;

    formInputEl.addEventListener('keyup', function (e) {
        if (e.key == "Escape") {
            SearchDesktop.toggleView();
        }
    });

    var searchOverlayEl = document.getElementById('search-desktop');

    document.addEventListener('click', function (e) {

        if (DOMHelper.isNodeOrIsChildOfNode(e.target, searchOverlayEl)) return;

        if (e.target.matches('.site-header__search') || DOMHelper.queryParentEl(e.target, '.site-header__search')) {
            return;
        }

        if (document.documentElement.classList.contains('search-desktop--isVisible')) {
            document.documentElement.classList.remove('search-desktop--isVisible');
        }
    });
})();
'use strict';

(function () {

    var searchFormEls = document.querySelectorAll('form[action="/search"]');

    for (var i = 0; i < searchFormEls.length; i++) {
        searchFormEls[i].addEventListener('submit', function (e) {
            var serchQueryInputEl = this.querySelector('input[name="q"]');

            if (serchQueryInputEl && searcQueryInputEl.indexOf('*') == -1) {
                e.preventDefault();
                serchQueryInputEl.value += "*";
                this.submit();
            }
        });
    }
})();
'use strict';

var SearchMobile = {

    toggleView: function toggleView() {
        var htmlEl = document.documentElement;

        if (htmlEl.classList.contains('drawer-menu__isVisible')) {
            htmlEl.classList.remove('drawer-menu__isVisible');
        }

        if (htmlEl.classList.contains('search-mobile--isVisible')) {
            // remove visible class to html element
            htmlEl.classList.remove('search-mobile--isVisible');
        } else {
            // add visible class to html element
            htmlEl.classList.add('search-mobile--isVisible');

            // focus on search input
            var searchMobileInput = document.querySelectorAll('.search-mobile form input[type=text]')[0];
            searchMobileInput.focus();
        }
    }
};
'use strict';

(function () {
    var headerImageNextBtns = document.querySelectorAll('.next-section-arrow');
    var headerImagePrevBtns = document.querySelectorAll('.previous-section-arrow');

    for (var i = 0; i < headerImageNextBtns.length; i++) {

        // headerImageNextBtns[i].addEventListener('mouseover', function(e) {
        //     //Do nothing if touch device
        //     if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        //     if (this.parentNode.clientHeight < window.innerHeight && !this.parentNode.classList.contains('first-block')) return;

        //     var nextEl = this.parentNode.nextElementSibling ? this.parentNode.nextElementSibling : this.parentNode.parentNode.nextElementSibling;

        //     if (!nextEl) return;

        //     nextEl.classList.add('peek-preview');
        // });
        // headerImageNextBtns[i].addEventListener('mouseout', function(e) {
        //     //Do nothing if touch device
        //     if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;

        //     var nextEl = this.parentNode.nextElementSibling ? this.parentNode.nextElementSibling : this.parentNode.parentNode.nextElementSibling;
        //     if (!nextEl) return;

        //     nextEl.classList.remove('peek-preview');
        // });


        headerImageNextBtns[i].addEventListener('click', function (e) {
            e.preventDefault();

            var nextEl = this.parentNode.nextElementSibling ? this.parentNode.nextElementSibling : this.parentNode.parentNode.nextElementSibling;
            if (!nextEl) return;

            window.scrollTo(document.documentElement, nextEl.offsetTop + 100, 500);
        });
    }

    for (var _i = 0; _i < headerImagePrevBtns.length; _i++) {
        headerImagePrevBtns[_i].addEventListener('click', function (e) {
            var prevEl = this.parentNode.previousElementSibling ? this.parentNode.previousElementSibling : this.parentNode.parentNode.previousElementSibling;
            if (!prevEl) return;
            window.scrollTo(document.documentElement, prevEl.offsetTop, 500);
        });
    }
})();
'use strict';

(function () {
    var adjusterEls = document.querySelectorAll('.js-qty.simple-qty-adjust .js-qty__adjust');

    for (var i = 0; i < adjusterEls.length; i++) {
        adjusterEls[i].addEventListener('click', function (e) {
            e.preventDefault();

            var qtyInputEl = this.parentNode.querySelector('.js-qty__num');

            if (qtyInputEl) {

                var minQty = parseInt(qtyInputEl.min);

                if (isNaN(minQty)) {
                    minQty = 1;
                }

                var currentQty = parseInt(qtyInputEl.value);
                if (isNaN(currentQty)) {
                    currentQty = 1;
                }

                if (this.classList.contains('js-qty__adjust--minus') && currentQty - 1 >= minQty) {
                    currentQty--;
                }

                if (this.classList.contains('js-qty__adjust--plus')) {
                    currentQty++;
                }

                qtyInputEl.value = currentQty;
            }
        });
    }
})();
'use strict';

(function () {

    var sizeGuideModalEl = document.getElementById('SizeGuideModal');

    if (sizeGuideModalEl) {
        var sizeGuideCloseBtn = document.getElementById('SizeGuideClose');
        var sizeGuideDisplayTriggerEl = document.getElementById('SizeGuideDisplay');
        if (sizeGuideCloseBtn) {
            sizeGuideCloseBtn.addEventListener('click', function () {
                sizeGuideModalEl.classList.remove('active');
            });
        }
        if (sizeGuideDisplayTriggerEl) {
            sizeGuideDisplayTriggerEl.addEventListener('click', function (e) {
                e.preventDefault();
                sizeGuideModalEl.classList.add('active');
            });
        }
    }

    var sizeTableEl = document.getElementById('SizeTable');
    var unitToggleEl = document.getElementById('SizeGuideUnitToggle');

    if (unitToggleEl) {
        unitToggleEl.addEventListener('change', function () {
            if (!sizeTableEl) return;
            if (this.checked) {
                sizeTableEl.classList.remove('cm');
                sizeTableEl.classList.add('inch');
            } else {
                sizeTableEl.classList.add('cm');
                sizeTableEl.classList.remove('inch');
            }
        });
    }
})();
'use strict';

(function () {

    //Supposed to be snap scroll, doesn't do so well

    return;

    var scrollThreshold = 100;

    var snapScrollEls = document.getElementsByClassName('snapscroll');
    var inViewSnapScrollEl = null;
    var lastScrollTop = document.documentElement.scrollTop;
    var direction = 'down';

    var moving = false;

    window.addEventListener('scroll', function (e) {

        direction = document.documentElement.scrollTop < lastScrollTop ? 'up' : 'down';

        lastScrollTop = document.documentElement.scrollTop;

        if (moving) {
            console.log("MOVING");
            return;
        }

        var found = null;
        //First we must find which element is in view
        for (var i = 0; i < snapScrollEls.length; i++) {
            var rect = snapScrollEls[i].getBoundingClientRect();

            if (rect.top >= document.documentElement.scrollTop - 100 && rect.bottom >= document.documentElement.scrollTop + rect.height) {
                found = snapScrollEls[i];
                break;
            }
        }

        if (inViewSnapScrollEl) {

            if (!found || !inViewSnapScrollEl.isSameNode(found)) {

                var scrollToEl = null;

                if (direction == 'up') {

                    if (!inViewSnapScrollEl.classList.contains('first-block')) {
                        scrollToEl = inViewSnapScrollEl.previousElementSibling || inViewSnapScrollEl.parentNode.previousElementSibling;
                    }
                } else {
                    scrollToEl = inViewSnapScrollEl.nextElementSibling || inViewSnapScrollEl.parentNode.nextElementSibling;
                }

                if (scrollToEl) {
                    console.log(scrollToEl);
                    moving = true;
                    window.scrollTo(document.documentElement, scrollToEl.offsetTop + 100, 500);

                    setTimeout(function () {
                        moving = false;
                    }, 800);
                }
            }
        }

        if (found) {
            inViewSnapScrollEl = found;
        }

        if (!inViewSnapScrollEl) return;

        console.log(inViewSnapScrollEl);
    });
})();
'use strict';

(function () {

    var params = {
        view: null,
        sort_by: null,
        constraint: []
    };

    var filterTagLinkEls = document.querySelectorAll('li[data-filter-tag-value]');

    if (window.location.search.indexOf('view=') != -1) {
        params.view = window.location.search.substring(1).split('view=').pop().split('&')[0];
    }

    if (window.location.search.indexOf('sort_by=') != -1) {
        params.sort_by = window.location.search.substring(1).split('sort_by=').pop().split('&')[0];
    }

    for (var i = 0; i < filterTagLinkEls.length; i++) {
        if (!filterTagLinkEls[i].classList.contains('active')) continue;
        params.constraint.push(filterTagLinkEls[i].dataset.filterTagValue);
    }

    $(document).on('click', '.max-products-toggle', function (e) {
        e.preventDefault();
        params.view = this.href.substring(1).split('view=').pop();
        $('#dropdownProductsPerPage span').text(this.innerText);
        window.dcAjaxUpdateResults();
    });

    $(document).on('click', '.sort-by-toggle', function (e) {
        e.preventDefault();
        params.sort_by = this.href.substring(1).split('sort_by=').pop();
        window.dcAjaxUpdateResults();
    });

    $(document).on('click', 'li[data-filter-tag-value]', function (e) {
        e.preventDefault();

        if (this.classList.contains('active')) {
            this.classList.remove('active');

            var indexInParamContraint = params.constraint.indexOf(this.dataset.filterTagValue);

            if (indexInParamContraint != -1) {
                params.constraint.splice(indexInParamContraint, 1);
            }
        } else {
            params.constraint.push(this.dataset.filterTagValue);
            this.classList.add('active');
        }
        window.dcAjaxUpdateResults();
    });

    window.dcAjaxUpdateResults = function () {

        var reqParams = {};

        for (var param in params) {
            if (!params[param]) continue;
            if (Array.isArray(params[param]) && params[param].length < 1) continue;
            reqParams[param] = params[param];
        }

        window.history.replaceState({}, document.title, window.location.pathname + '?' + $.param(reqParams));
        $.get(window.location.pathname, reqParams, function (response) {

            if (response.indexOf('<!--__BEGIN_COLLECTION_PRODUCTS__-->') != -1 && response.indexOf('<!--__END_COLLECTION_PRODUCTS__-->') != -1) {
                var productsListHTML = response.split('<!--__BEGIN_COLLECTION_PRODUCTS__-->').pop().split('<!--__END_COLLECTION_PRODUCTS__-->')[0];
                $('#CollectionProducts').html(productsListHTML);
            }

            if (response.indexOf('<!--__BEGIN_NUMBERED_PAGINATION__-->') != -1 && response.indexOf('<!--__END_NUMBERED_PAGINATION__-->') != -1) {
                var paginationHTML = response.split('<!--__BEGIN_NUMBERED_PAGINATION__-->').pop().split('<!--__END_NUMBERED_PAGINATION__-->')[0];
                $('#NumberedPagination').html(paginationHTML);
            }

            if (response.indexOf('<!--__BEGIN_TAG_FILTERS__-->') != -1 && response.indexOf('<!--__END_TAG_FILTERS__-->') != -1) {
                var tagFiltersHTML = response.split('<!--__BEGIN_TAG_FILTERS__-->').pop().split('<!--__END_TAG_FILTERS__-->')[0];
                $('#CollectionTagFilters').html(tagFiltersHTML);
            }
        });
    };

    var filterBtnEls = document.getElementsByClassName('dc-dropdown-btn');

    if (filterBtnEls.length > 0) {

        var filterCloseBtnEls = document.querySelectorAll('.dropdown-menu-header .cross-icon');

        document.addEventListener('click', function (e) {

            for (var _i = 0; _i < filterCloseBtnEls.length; _i++) {
                if (!filterCloseBtnEls[_i].parentNode.parentNode.parentNode.classList.contains('open')) continue;
                if (DOMHelper.isNodeOrIsChildOfNode(e.target, filterCloseBtnEls[_i])) {
                    filterCloseBtnEls[_i].parentNode.parentNode.parentNode.classList.remove('open');
                    document.documentElement.classList.remove('dc-dropdown-open');
                    return;
                }
            }

            for (var _i2 = 0; _i2 < filterBtnEls.length; _i2++) {

                if (!filterBtnEls[_i2].parentNode.classList.contains('open')) {
                    if (DOMHelper.isNodeOrIsChildOfNode(e.target, filterBtnEls[_i2].parentNode)) {
                        filterBtnEls[_i2].parentNode.classList.add('open');
                        document.documentElement.classList.add('dc-dropdown-open');
                    }
                } else if (filterBtnEls[_i2].id == 'dropdownFilter') {
                    if (!DOMHelper.isNodeOrIsChildOfNode(e.target, filterBtnEls[_i2].parentNode.children[1])) {
                        filterBtnEls[_i2].parentNode.classList.remove('open');
                    }
                } else {
                    filterBtnEls[_i2].parentNode.classList.remove('open');
                }
            }
        });
    }
})();
'use strict';

jQuery(function ($) {
	$('[data-slick-spotlight]').slick({
		dots: false,
		infinite: false,
		speed: 300,
		slidesToShow: 3,
		slidesToScroll: 1,
		prevArrow: '<button class="cta-arrow arrow-left arrow-white"><i></i></button>',
		nextArrow: '<button class="cta-arrow arrow-right arrow-white"><i></i></button>',
		responsive: [{
			breakpoint: 1024,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 3,
				infinite: true,
				dots: false
			}
		}, {
			breakpoint: 600,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}]
	});

	$('[data-slick-garage]').slick({
		dots: false,
		infinite: false,
		speed: 300,
		slidesToShow: 3,
		slidesToScroll: 1,
		prevArrow: '<button class="cta-arrow arrow-left arrow-white"><i></i></button>',
		nextArrow: '<button class="cta-arrow arrow-right arrow-white"><i></i></button>',
		responsive: [{
			breakpoint: 1024,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 3,
				infinite: true,
				dots: false
			}
		}, {
			breakpoint: 600,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}]
	});
});
'use strict';

var ToggleColumnSize = {

    switch: function _switch(el) {

        var newColumnSize = el.dataset.columnSize;

        ToggleColumnSize.setLayout(newColumnSize);
    },

    setLayout: function setLayout(newColumnSize) {

        var htmlEl = document.documentElement;

        ToggleColumnSize.setCookie('dc_collection-bike-column-size', newColumnSize, 30);

        htmlEl.classList.remove('toggleColumnSize--narrow-columns');
        htmlEl.classList.remove('toggleColumnSize--wide-columns');

        htmlEl.classList.add('toggleColumnSize--' + newColumnSize);
    },

    setCookie: function setCookie(name, value, days) {

        var expires = "";

        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = "; expires=" + date.toUTCString();
        }

        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    },

    getCookie: function getCookie(name) {

        var nameEQ = name + "=";
        var ca = document.cookie.split(';');

        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1, c.length);
            }if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }

        return null;
    },

    init: function init() {

        var cookieValue = ToggleColumnSize.getCookie('dc_collection-bike-column-size');

        if (!cookieValue) {
            ToggleColumnSize.setCookie('collection-bike-column-size', 'narrow-columns', 30);
            cookieValue = 'narrow-columns';
        }

        ToggleColumnSize.setLayout(cookieValue);
    }
};
'use strict';

(function () {

    var vimeoPlayerEls = document.querySelectorAll('.vimeo-player');

    if (vimeoPlayerEls.length < 1) return;

    console.log(vimeoPlayerEls);

    var vimeoPlayerAPIScript = document.createElement('script');
    vimeoPlayerAPIScript.type = 'text/javascript';
    vimeoPlayerAPIScript.src = 'https://player.vimeo.com/api/player.js';

    var vimeoPlayers = [];

    vimeoPlayerAPIScript.addEventListener('load', function () {

        for (var i = 0; i < vimeoPlayerEls.length; i++) {

            console.log(vimeoPlayerEls[i].parentNode.clientHeight);
            console.log(vimeoPlayerEls[i].parentNode.clientWidth);

            var playerOptions = {
                muted: true,
                background: true,
                controls: false,
                title: false,
                portrait: false,
                autoplay: true,
                loop: true,
                height: vimeoPlayerEls[i].parentNode.clientHeight,
                widht: vimeoPlayerEls[i].parentNode.clientWidth,
                playsinline: true,
                url: 'https://player.vimeo.com/video/' + vimeoPlayerEls[i].dataset.vimeoVideoId
            };

            vimeoPlayerEls[i].setAttribute('data-player-index', i);

            var player = new Vimeo.Player(vimeoPlayerEls[i], playerOptions);
            vimeoPlayers.push(player);
        }
    });

    document.head.appendChild(vimeoPlayerAPIScript);
})();
'use strict';

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['module', 'exports'], factory);
  } else if (typeof exports !== "undefined") {
    factory(module, exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports);
    global.WOW = mod.exports;
  }
})(window, function (module, exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _class, _temp;

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function isIn(needle, haystack) {
    return haystack.indexOf(needle) >= 0;
  }

  function extend(custom, defaults) {
    for (var key in defaults) {
      if (custom[key] == null) {
        var value = defaults[key];
        custom[key] = value;
      }
    }
    return custom;
  }

  function isMobile(agent) {
    return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(agent)
    );
  }

  function createEvent(event) {
    var bubble = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
    var cancel = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
    var detail = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];

    var customEvent = void 0;
    if (document.createEvent != null) {
      // W3C DOM
      customEvent = document.createEvent('CustomEvent');
      customEvent.initCustomEvent(event, bubble, cancel, detail);
    } else if (document.createEventObject != null) {
      // IE DOM < 9
      customEvent = document.createEventObject();
      customEvent.eventType = event;
    } else {
      customEvent.eventName = event;
    }

    return customEvent;
  }

  function emitEvent(elem, event) {
    if (elem.dispatchEvent != null) {
      // W3C DOM
      elem.dispatchEvent(event);
    } else if (event in (elem != null)) {
      elem[event]();
    } else if ('on' + event in (elem != null)) {
      elem['on' + event]();
    }
  }

  function addEvent(elem, event, fn) {
    if (elem.addEventListener != null) {
      // W3C DOM
      elem.addEventListener(event, fn, false);
    } else if (elem.attachEvent != null) {
      // IE DOM
      elem.attachEvent('on' + event, fn);
    } else {
      // fallback
      elem[event] = fn;
    }
  }

  function removeEvent(elem, event, fn) {
    if (elem.removeEventListener != null) {
      // W3C DOM
      elem.removeEventListener(event, fn, false);
    } else if (elem.detachEvent != null) {
      // IE DOM
      elem.detachEvent('on' + event, fn);
    } else {
      // fallback
      delete elem[event];
    }
  }

  function getInnerHeight() {
    if ('innerHeight' in window) {
      return window.innerHeight;
    }

    return document.documentElement.clientHeight;
  }

  // Minimalistic WeakMap shim, just in case.
  var WeakMap = window.WeakMap || window.MozWeakMap || function () {
    function WeakMap() {
      _classCallCheck(this, WeakMap);

      this.keys = [];
      this.values = [];
    }

    _createClass(WeakMap, [{
      key: 'get',
      value: function get(key) {
        for (var i = 0; i < this.keys.length; i++) {
          var item = this.keys[i];
          if (item === key) {
            return this.values[i];
          }
        }
        return undefined;
      }
    }, {
      key: 'set',
      value: function set(key, value) {
        for (var i = 0; i < this.keys.length; i++) {
          var item = this.keys[i];
          if (item === key) {
            this.values[i] = value;
            return this;
          }
        }
        this.keys.push(key);
        this.values.push(value);
        return this;
      }
    }]);

    return WeakMap;
  }();

  // Dummy MutationObserver, to avoid raising exceptions.
  var MutationObserver = window.MutationObserver || window.WebkitMutationObserver || window.MozMutationObserver || (_temp = _class = function () {
    function MutationObserver() {
      _classCallCheck(this, MutationObserver);

      if (typeof console !== 'undefined' && console !== null) {
        console.warn('MutationObserver is not supported by your browser.');
        console.warn('WOW.js cannot detect dom mutations, please call .sync() after loading new content.');
      }
    }

    _createClass(MutationObserver, [{
      key: 'observe',
      value: function observe() {}
    }]);

    return MutationObserver;
  }(), _class.notSupported = true, _temp);

  // getComputedStyle shim, from http://stackoverflow.com/a/21797294
  var getComputedStyle = window.getComputedStyle || function getComputedStyle(el) {
    var getComputedStyleRX = /(\-([a-z]){1})/g;
    return {
      getPropertyValue: function getPropertyValue(prop) {
        if (prop === 'float') {
          prop = 'styleFloat';
        }
        if (getComputedStyleRX.test(prop)) {
          prop.replace(getComputedStyleRX, function (_, _char) {
            return _char.toUpperCase();
          });
        }
        var currentStyle = el.currentStyle;

        return (currentStyle != null ? currentStyle[prop] : void 0) || null;
      }
    };
  };

  var WOW = function () {
    function WOW() {
      var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

      _classCallCheck(this, WOW);

      this.defaults = {
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        mobile: true,
        live: true,
        callback: null,
        scrollContainer: null,
        resetAnimation: true
      };

      this.animate = function animateFactory() {
        if ('requestAnimationFrame' in window) {
          return function (callback) {
            return window.requestAnimationFrame(callback);
          };
        }
        return function (callback) {
          return callback();
        };
      }();

      this.vendors = ['moz', 'webkit'];

      this.start = this.start.bind(this);
      this.resetAnimation = this.resetAnimation.bind(this);
      this.scrollHandler = this.scrollHandler.bind(this);
      this.scrollCallback = this.scrollCallback.bind(this);
      this.scrolled = true;
      this.config = extend(options, this.defaults);
      if (options.scrollContainer != null) {
        this.config.scrollContainer = document.querySelector(options.scrollContainer);
      }
      // Map of elements to animation names:
      this.animationNameCache = new WeakMap();
      this.wowEvent = createEvent(this.config.boxClass);
    }

    _createClass(WOW, [{
      key: 'init',
      value: function init() {
        this.element = window.document.documentElement;
        if (isIn(document.readyState, ['interactive', 'complete'])) {
          this.start();
        } else {
          addEvent(document, 'DOMContentLoaded', this.start);
        }
        this.finished = [];
      }
    }, {
      key: 'start',
      value: function start() {
        var _this = this;

        this.stopped = false;
        this.boxes = [].slice.call(this.element.querySelectorAll('.' + this.config.boxClass));
        this.all = this.boxes.slice(0);
        if (this.boxes.length) {
          if (this.disabled()) {
            this.resetStyle();
          } else {
            for (var i = 0; i < this.boxes.length; i++) {
              var box = this.boxes[i];
              this.applyStyle(box, true);
            }
          }
        }
        if (!this.disabled()) {
          addEvent(this.config.scrollContainer || window, 'scroll', this.scrollHandler);
          addEvent(window, 'resize', this.scrollHandler);
          this.interval = setInterval(this.scrollCallback, 50);
        }
        if (this.config.live) {
          var mut = new MutationObserver(function (records) {
            for (var j = 0; j < records.length; j++) {
              var record = records[j];
              for (var k = 0; k < record.addedNodes.length; k++) {
                var node = record.addedNodes[k];
                _this.doSync(node);
              }
            }
            return undefined;
          });
          mut.observe(document.body, {
            childList: true,
            subtree: true
          });
        }
      }
    }, {
      key: 'stop',
      value: function stop() {
        this.stopped = true;
        removeEvent(this.config.scrollContainer || window, 'scroll', this.scrollHandler);
        removeEvent(window, 'resize', this.scrollHandler);
        if (this.interval != null) {
          clearInterval(this.interval);
        }
      }
    }, {
      key: 'sync',
      value: function sync() {
        if (MutationObserver.notSupported) {
          this.doSync(this.element);
        }
      }
    }, {
      key: 'doSync',
      value: function doSync(element) {
        if (typeof element === 'undefined' || element === null) {
          element = this.element;
        }
        if (element.nodeType !== 1) {
          return;
        }
        element = element.parentNode || element;
        var iterable = element.querySelectorAll('.' + this.config.boxClass);
        for (var i = 0; i < iterable.length; i++) {
          var box = iterable[i];
          if (!isIn(box, this.all)) {
            this.boxes.push(box);
            this.all.push(box);
            if (this.stopped || this.disabled()) {
              this.resetStyle();
            } else {
              this.applyStyle(box, true);
            }
            this.scrolled = true;
          }
        }
      }
    }, {
      key: 'show',
      value: function show(box) {
        this.applyStyle(box);
        box.className = box.className + ' ' + this.config.animateClass;
        if (this.config.callback != null) {
          this.config.callback(box);
        }
        emitEvent(box, this.wowEvent);

        if (this.config.resetAnimation) {
          addEvent(box, 'animationend', this.resetAnimation);
          addEvent(box, 'oanimationend', this.resetAnimation);
          addEvent(box, 'webkitAnimationEnd', this.resetAnimation);
          addEvent(box, 'MSAnimationEnd', this.resetAnimation);
        }

        return box;
      }
    }, {
      key: 'applyStyle',
      value: function applyStyle(box, hidden) {
        var _this2 = this;

        var duration = box.getAttribute('data-wow-duration');
        var delay = box.getAttribute('data-wow-delay');
        var iteration = box.getAttribute('data-wow-iteration');

        return this.animate(function () {
          return _this2.customStyle(box, hidden, duration, delay, iteration);
        });
      }
    }, {
      key: 'resetStyle',
      value: function resetStyle() {
        for (var i = 0; i < this.boxes.length; i++) {
          var box = this.boxes[i];
          box.style.visibility = 'visible';
        }
        return undefined;
      }
    }, {
      key: 'resetAnimation',
      value: function resetAnimation(event) {
        if (event.type.toLowerCase().indexOf('animationend') >= 0) {
          var target = event.target || event.srcElement;
          target.className = target.className.replace(this.config.animateClass, '').trim();
        }
      }
    }, {
      key: 'customStyle',
      value: function customStyle(box, hidden, duration, delay, iteration) {
        if (hidden) {
          this.cacheAnimationName(box);
        }
        box.style.visibility = hidden ? 'hidden' : 'visible';

        if (duration) {
          this.vendorSet(box.style, { animationDuration: duration });
        }
        if (delay) {
          this.vendorSet(box.style, { animationDelay: delay });
        }
        if (iteration) {
          this.vendorSet(box.style, { animationIterationCount: iteration });
        }
        this.vendorSet(box.style, { animationName: hidden ? 'none' : this.cachedAnimationName(box) });

        return box;
      }
    }, {
      key: 'vendorSet',
      value: function vendorSet(elem, properties) {
        for (var name in properties) {
          if (properties.hasOwnProperty(name)) {
            var value = properties[name];
            elem['' + name] = value;
            for (var i = 0; i < this.vendors.length; i++) {
              var vendor = this.vendors[i];
              elem['' + vendor + name.charAt(0).toUpperCase() + name.substr(1)] = value;
            }
          }
        }
      }
    }, {
      key: 'vendorCSS',
      value: function vendorCSS(elem, property) {
        var style = getComputedStyle(elem);
        var result = style.getPropertyCSSValue(property);
        for (var i = 0; i < this.vendors.length; i++) {
          var vendor = this.vendors[i];
          result = result || style.getPropertyCSSValue('-' + vendor + '-' + property);
        }
        return result;
      }
    }, {
      key: 'animationName',
      value: function animationName(box) {
        var aName = void 0;
        try {
          aName = this.vendorCSS(box, 'animation-name').cssText;
        } catch (error) {
          // Opera, fall back to plain property value
          aName = getComputedStyle(box).getPropertyValue('animation-name');
        }

        if (aName === 'none') {
          return ''; // SVG/Firefox, unable to get animation name?
        }

        return aName;
      }
    }, {
      key: 'cacheAnimationName',
      value: function cacheAnimationName(box) {
        // https://bugzilla.mozilla.org/show_bug.cgi?id=921834
        // box.dataset is not supported for SVG elements in Firefox
        return this.animationNameCache.set(box, this.animationName(box));
      }
    }, {
      key: 'cachedAnimationName',
      value: function cachedAnimationName(box) {
        return this.animationNameCache.get(box);
      }
    }, {
      key: 'scrollHandler',
      value: function scrollHandler() {
        this.scrolled = true;
      }
    }, {
      key: 'scrollCallback',
      value: function scrollCallback() {
        if (this.scrolled) {
          this.scrolled = false;
          var results = [];
          for (var i = 0; i < this.boxes.length; i++) {
            var box = this.boxes[i];
            if (box) {
              if (this.isVisible(box)) {
                this.show(box);
                continue;
              }
              results.push(box);
            }
          }
          this.boxes = results;
          if (!this.boxes.length && !this.config.live) {
            this.stop();
          }
        }
      }
    }, {
      key: 'offsetTop',
      value: function offsetTop(element) {
        // SVG elements don't have an offsetTop in Firefox.
        // This will use their nearest parent that has an offsetTop.
        // Also, using ('offsetTop' of element) causes an exception in Firefox.
        while (element.offsetTop === undefined) {
          element = element.parentNode;
        }
        var top = element.offsetTop;
        while (element.offsetParent) {
          element = element.offsetParent;
          top += element.offsetTop;
        }
        return top;
      }
    }, {
      key: 'isVisible',
      value: function isVisible(box) {
        var offset = box.getAttribute('data-wow-offset') || this.config.offset;
        var viewTop = this.config.scrollContainer && this.config.scrollContainer.scrollTop || window.pageYOffset;
        var viewBottom = viewTop + Math.min(this.element.clientHeight, getInnerHeight()) - offset;
        var top = this.offsetTop(box);
        var bottom = top + box.clientHeight;

        return top <= viewBottom && bottom >= viewTop;
      }
    }, {
      key: 'disabled',
      value: function disabled() {
        return !this.config.mobile && isMobile(navigator.userAgent);
      }
    }]);

    return WOW;
  }();

  exports.default = WOW;
  module.exports = exports['default'];
});

new WOW().init();